const translations = {
    en: {
        // Shown in the browser tab / OS notification, i.e. while the user is
        // looking at some other tab.
        tab: {
            newMessage: "💬 New message!",
            newMessageBody: "You have a new message on Astreona.",
            enableTitle: "Desktop notifications",
            enableDesc: "Get notified when a message arrives while this tab is in the background.",
            enableBtn: "Enable notifications",
            enabled: "Notifications enabled",
            blocked: "Notifications are blocked in your browser settings.",
            unsupported: "Your browser does not support desktop notifications."
        },
        notfound: {
            title: "Looks like you're lost",
            desc: "The page you are looking for is not available!",
            home: "Go to Home"
        },
        landing: {
            login: "Login",
            signup: "Sign Up",
            badge: "SECURE MESSAGING",
            heading1: "Encrypted.",
            heading2: "Anonymous.",
            heading3: "Bot-Free.",
            sub1: "Connect Securely.",
            sub2: "Share Freely.",
            pill1: "🔒 End-to-End Encrypted",
            pill2: "🕶️ Anonymous Identity",
            pill3: "🤖 No Bots"
        },
        login: {
            back: "Back",
            title: "Log in to your account",
            usernameLabel: "Username or Email",
            usernamePlaceholder: "Username",
            passwordLabel: "Password",
            passwordPlaceholder: "Password",
            submit: "Login",
            forgot: "Forgot password?",
            or: "or",
            google: "Login with Google",
            errorAlert: "An error occurred. Please try again."
        },
        register: {
            back: "Back",
            title: "Sign Up",
            usernameLabel: "Username",
            usernamePlaceholder: "Username",
            emailLabel: "Email address",
            emailPlaceholder: "Email",
            passwordLabel: "Password",
            passwordPlaceholder: "Password",
            noSpaces: "Password cannot contain spaces",
            confirmLabel: "Password confirmation",
            confirmPlaceholder: "Confirm password",
            codePlaceholder: "Enter 6-digit code",
            resend: "Resend",
            spamNote: "Check spam folder and mark as not spam.",
            submit: "Sign Up",
            terms: "By clicking Sign up, you agree to the",
            termsLink: "terms of use",
            and: "and",
            privacyLink: "privacy policy",
            termsEnd: ".",
            or: "or",
            google: "Sign up with Google",
            error: "Something went wrong!",
            codeSent: "code sent"
        },
        forget: {
            title0: "Find Your Account",
            desc0: "Enter the email address or username associated with your account.",
            label0: "Email address or username",
            submit: "Submit",
            title1: "Send Confirmation Code",
            desc1: "Before changing your password, we need to verify your identity.",
            sendEmail: "Send an e-mail to ",
            title2: "We Sent You a Code",
            desc2: "Check if you received the verification code. Go back to request a new one.",
            label2: "Enter Code",
            placeholder2: "Enter Code",
            spamNote: "Check spam folder and mark as not spam.",
            back: "Back",
            title3: "Choose New Password",
            desc3: "Make sure your new password is 8 or more characters long.",
            newPlaceholder: "New password",
            confirmPlaceholder: "Confirm password",
            noSpaces: "Password cannot contain spaces"
        },
        nav: {
            payAlert: "You must pay to use this feature. Please go to Settings → Payments"
        },
        settings: {
            title: "Settings",
            tabAccount: "Account",
            tabPayments: "Payments",
            tabContact: "Contact Us - Help Center - Requests and suggestions",
            spoken: "Spoken",
            stars: "Stars",
            spokenInfo: "This counter tracks the total number of people you have messaged.",
            subsTitle: "Unlocked",
            subsTotal: "total",
            subsEmpty: "No unlocked creators yet.",
            subsStarted: "Started",
            subsCancelsAtEnd: "",
            // subsCancelsAtEnd: "Cancels at period end",
            subsEnded: "Ended",
            subsStatusEnded: "Ended",
            subsStatusCanceling: "Canceling",
            subsStatusActive: "Active",
            subsStatusInactive: "Inactive",
            subsExpired: "Expired",
            subsReactivate: "Reactivate",
            subsCancel: "Cancel"
        },
        account: {
            generalInfo: "General Information",
            accountOpened: "Account opened:",
            changeName: "Change Name",
            usernamePlaceholder: "username",
            nameChanged: "name changed",
            usernameExists: "A user with that username already exists.",
            saveBtn: "Save",
            emailTitle: "E-mail",
            changeBtn: "Change",
            addBtn: "Add",
            changeEmailTitle: "Change E-mail",
            newEmailPlaceholder: "Enter new e-mail address",
            usingThisEmail: "you are using this email",
            codeSent: "code sent",
            codeNotSent: "We could not send a code to this address. Please check it and try again.",
            enterCodePlaceholder: "Enter code",
            resendBtn: "Resend",
            checkSpam: "Check spam folder and mark as not spam.",
            submitBtn: "Submit",
            closeBtn: "Close",
            passwordTitle: "Password",
            changePasswordBtn: "Change Password",
            changePasswordTitle: "Change Password",
            currentPasswordPlaceholder: "Current password",
            forgotPasswordLabel: "Forgot password?",
            newPasswordPlaceholder: "New password",
            confirmPasswordPlaceholder: "Confirm password",
            terminateSessions: "When you change your password, other sessions will be terminated.",
            logoutBtn: "Logout",
            deleteAccountBtn: "Delete Account",
            confirmDelete: "Please enter",
            confirmDeleteSuffix: "to confirm",
            activeSubAlert: "You have an active subscription. Please cancel your subscription first.",
            cancelBtn: "Cancel",
            manageSubBtn: "Manage Subscription",
            deleteBtn: "Delete",
            passwordSameAlert: "new password cannot be the same as the old password",
            passwordsNotMatch: "passwords do not match",
            passwordChanged: "password changed"
        },
        payments: {
            errorPortal: "The subscription could not be updated.",
            promoInvalid: "Promo Code is not valid.",
            subscribeTitle: "Trial period has ended.",
            subscribeDesc: "Please pay the login fee to access.",
            payNowBtn: "Subscribe now",
            promoTitle: "Promo Code",
            promoPlaceholder: "Enter promo code",
            applyCodeBtn: "Apply Code",
            lifetimePromo: "You have a lifetime valid promotional code",
            manageSubTitle: "Manage Subscription",
            manageSubBtn: "Manage Subscription",
            subDetailsTitle: "Subscription Details",
            startedAt: "Started at",
            cancelAt: "Cancel at",
            canceledAt: "Canceled at",
            status: "Status",
            buyStarsTitle: "Buy Stars",
            buyStarsDesc: "Get more stars to message new people",
            starAmountLabel: "How many stars do you want?",
            starRate: "1 ★ = $1",
            starTotal: "Total",
            buyStarsBtn: "Continue to payment",
            starCheckoutNote: "Paid with your card right here. Your stars are added as soon as the payment clears.",
            starSheetHint: "{count} stars",
            starsAdded: "{count} stars added",
            starsAddedDetail: "They are in your balance and ready to send.",
            mostPopular: "Most Popular",
            bestValue: "Best Value",
            newMessagesAlert: "You have new messages",

            // Managing a live subscription, all of it in the app — this used to
            // be one button that opened the Stripe billing portal.
            updateCardBtn: "Update card",
            updateCardTitle: "Payment method",
            updateCardHint: "The new card is used for your next renewal.",
            cardUpdated: "Card updated",
            cardUpdatedDetail: "Your next renewal uses the new card.",
            cancelSubBtn: "Cancel subscription",
            cancelSubConfirmBtn: "Yes, cancel",
            cancelConfirm: "Your subscription stays active until the end of the period you have paid for, then stops renewing.",
            reactivateBtn: "Resume subscription",
            willCancelNote: "This subscription is set to stop at the end of the current period."
        },

        // Shown when `api/UserData/` cannot be loaded at all.
        session: {
            title: "We couldn't load your account",
            desc: "The server did not answer. Check your connection and try again.",
            retry: "Try again",
        },

        // Shared by every payment sheet in the app.
        billing: {
            payNow: "Pay now",
            cancel: "Cancel",
            close: "Close",
            continue: "Continue",
            retry: "Try again",
            amountToPay: "To pay",
            perMonth: "Monthly",
            perMonthShort: "/mo",
            securityNote: "Card details go straight to Stripe — they never reach our servers.",
            recurringNote: "Renews monthly. You can cancel any time.",
            subscribeNow: "Unlock",
            subscribeHint: "Paid here — you are not sent to another site.",
            subscribeToTitle: "Subscribe to {name}",
            creatorTerms: "{price} per month to {name}, until you cancel.",
            subscribedTitle: "You are subscribed",
            subscribedDetail: "Your subscription is active.",
            subscribedToCreator: "You are now subscribed to {name}.",
            subscriptionPending: "Payment received. The subscription will show as active in a moment.",
            paymentFailed: "The payment was declined.",
            paymentIncomplete: "The payment was not completed.",
            paymentProcessing: "The payment is being processed. This can take a moment.",
            startError: "The payment could not be started. Please try again.",
            noPublishableKey: "Card payments are not configured yet. Please contact support.",
            invalidAmount: "Enter a valid amount.",
            cardUpdateFailed: "The card was saved but could not be applied. Please try again.",
            alreadySubscribed: "You already have an active subscription.",
            planUnavailable: "Subscriptions are temporarily unavailable. Please try again later.",
            noPriceSet: "This creator has not set a subscription price yet.",
            subscriptionsClosed: "This creator is not accepting subscriptions.",
            notACreator: "This account does not offer subscriptions.",
            selfSubscription: "You cannot subscribe to yourself.",
            notFound: "Not found."
        },
        contact: {
            title: "Contact Us",
            desc: "Have questions or need assistance? We're here to help! Contact us anytime.",
            nameLabel: "Your Name",
            namePlaceholder: "Enter your name",
            emailLabel: "Email Address",
            emailPlaceholder: "Enter your email",
            subjectLabel: "Subject",
            subjectPlaceholder: "Enter the subject",
            messageLabel: "Message",
            messagePlaceholder: "Write your message here...",
            sendBtn: "Send Message",
            successMsg: "Your message has been received."
        },
        profile: {
            errorMsg: "Oops! An error occurred, please refresh the page",
            addLinkBtn: "Add Link",
            addLinkTitle: "Add Link",
            addLinkHint: "Any website. Known platforms get their own icon automatically.",
            addSocialMediaHint: "Pick the platform, then the username on it.",
            linkDetected: "Recognised",
            linkGeneric: "Website",
            useDetectedTitle: "Use",
            linkIsSocialTitle: "{platform} belongs in your social accounts",
            linkIsSocialBody: "Saved as a plain link it stays out of search and brand discovery. Add it as a social media account so your follower count is verified and brands can find you.",
            linkIsSocialAction: "Add as social media",
            linkIsSocialBadge: "Not searchable",
            deleteBtn: "Remove",
            backgroundTitle: "Profile background",
            backgroundHint: "The colour behind your profile card.",
            linkUrlPlaceholder: "Link URL",
            titlePlaceholder: "Title",
            submitBtn: "Submit",
            closeBtn: "Close",
            changePhotoBtn: "Change Photo",
            zoomLabel: "Zoom",
            saveBtn: "Save",
            editProfileBtn: "Edit Profile",
            deletePhotoBtn: "Delete Photo",
            bioTextLabel: "Bio text",
            bioPlaceholder: "Bio",
            bioHelp: "Keep it short and understandable.",
            visibleBtn: "Visible",
            visibleHelp: "Your account is visible. Click to hide it.",
            hiddenBtn: "Hidden",
            hiddenHelp: "Your account is hidden. Click to make it visible.",
            selectColor: "Select a Color",
            hex: "Hex",
            rgb: "RGB",
            saveColorBtn: "Save Color",
            thumbAdd: "Add a thumbnail",
            thumbReplace: "Change thumbnail",
            thumbRemove: "Remove thumbnail",
            thumbCropTitle: "Link thumbnail",
            thumbCropHint: "Square, shown at the start of the row.",
            thumbUploadError: "The image could not be uploaded. Please try again.",
            thumbSaveError: "The thumbnail could not be saved. Please try again.",
            viewBtn: "View",
            creatorToggleLabel: "Creator Mode",
            creatorToggleHelp: "Enable creator features on your profile.",
            verifiedBrand: "Verified Business",
            verifiedCreator: "Verified Creator",
            unverifiedBrand: "Unverified Business",
            unverifiedCreator: "Unverified Creator",
            addSocialMediaBtn: "Add Social Media",
            addSocialMediaTitle: "Add Social Media",
            platformSelect: "Select Platform",
            socialMediaUsernamePlaceholder: "Username (e.g. john_doe)",
            platformError: "Please select a platform.",
            usernameError: "Please enter a username.",
            inVerification: "In verification:",
            followers: "Followers:",
            approvalWarning: "Your social media account will be approved in a short time. If you think there is an error, contact us.",
            linkCopyWarning: "In order for us to verify your social media accounts and for other users to find you, you must specify your link in the bio or link sections of your social media account.",
            copyBtn: "Copy",
            copiedBtn: "Copied!",
            tagsLabel: "Profile Tags",
            tagPlaceholder: "Add a tag...",
            addTagBtn: "Add",
            locationsLabel: "Community Locations",
            locationPlaceholder: "Select a location...",
            requestVerification: "Request Verification",
            verificationRequested: "Verification Requested"
        },
        theme: {
            title: "Appearance",
            subtitle: "How your public profile looks to visitors.",
            save: "Publish",
            saveError: "Could not save. Please try again.",
            uploadError: "Could not upload the image. Please try again.",
            uploading: "Uploading…",
            remove: "Remove",

            tabPresets: "Templates",
            tabBackground: "Background",
            tabCard: "Card",
            tabText: "Type",
            tabButtons: "Buttons",

            presetsHint: "Pick a starting point, then change anything you like. Your wallpaper photo is kept.",
            presetClassic: "Classic",
            presetMidnight: "Midnight",
            presetMono: "Mono",
            presetSunset: "Sunset",
            presetOcean: "Ocean",
            presetSakura: "Sakura",
            presetForest: "Forest",
            presetNeon: "Neon",
            presetPaper: "Paper",
            presetBubblegum: "Bubblegum",
            presetSlate: "Slate",
            presetGold: "Gold",

            bgType: "Background",
            bgSolid: "Solid",
            bgGradient: "Gradient",
            bgImage: "Photo",
            bgColor: "Colour",
            bgColorFrom: "From",
            bgColorTo: "To",
            bgAngle: "Angle",
            bgPattern: "Pattern",
            bgPhoto: "Wallpaper",
            bgPhotoHint: "Cropped to a phone screen",
            bgPhotoPick: "Choose a photo",
            bgPhotoReplace: "Change photo",
            bgBlur: "Blur",
            bgDim: "Darken",
            pattern_none: "None",
            pattern_dots: "Dots",
            pattern_grid: "Grid",
            pattern_stripes: "Stripes",
            pattern_rays: "Rays",

            cardStyle: "Card",
            cardSolid: "Solid",
            cardGlass: "Glass",
            cardNone: "None",
            cardColor: "Card colour",
            cardBorder: "Border colour",
            cardOpacity: "Opacity",
            cardRadius: "Corner rounding",
            avatarShape: "Profile photo",
            avatarCircle: "Circle",
            avatarRounded: "Rounded",
            avatarSquare: "Square",

            font: "Font",
            textHeading: "Headings",
            textBody: "Body text",
            textMuted: "Secondary text",

            buttonsHint: "Your links and social accounts are the buttons on your profile.",
            btnFill: "Fill",
            fillSolid: "Solid",
            fillOutline: "Outline",
            fillGlass: "Glass",
            btnShadow: "Shadow",
            shadowNone: "None",
            shadowSoft: "Soft",
            shadowHard: "Hard",
            btnRadius: "Corner rounding",
            btnColor: "Button colour",
            btnText: "Button text",
            btnBorder: "Border colour",
            accent: "Accent",
            accentText: "Accent text",

            cropTitle: "Wallpaper",
            cropHint: "The part inside the frame is what visitors see.",

            previewBio: "Your bio appears here",
            previewRowA: "Instagram",
            previewRowB: "My website"
        },
        user: {
            linkDestination: "Where this link goes",
            openLink: "Open link",
            showLink: "Show link",
            linkWarning: "Check the address before you continue — it was entered by the profile owner.",
            contactBtn: "Contact",
            brandOnlyInbox: "This creator only accepts messages from brand accounts.",
            copyLink: "Copy profile link",
            closeBtn: "Close",
            unlock: "Unlock",
            buyCoffee: "Buy Coffee",
            coffeeName: "Name (Optional)",
            coffeeMessage: "Your message...",
            payCoffee: "Send",
            coffeeThanksTitle: "Thank you!",
            coffeeThanksMessage: "Coffee successfully sent."
        },
        search: {
            errorMsg: "An error occurred.",
            placeholder: "Search by username...",
            loadMore: "Load more",
            tabUsername: "By Username",
            tabSocial: "By Social Media",
            tabProfile: "By Profile",
            platform: "Platform",
            minFollowers: "Min Followers",
            maxFollowers: "Max Followers",
            sortBy: "Sort By",
            sortStandard: "Standard",
            sortMostFollowers: "Most followers first",
            sortLeastFollowers: "Least followers first",
            filterBtn: "Filter",
            clearFilters: "Clear Filters",
            tagsPlaceholder: "Categories (Tags)",
            addBtn: "Add",
            // The account's own listed countries — not an audience breakdown,
            // which is what the old label promised and never delivered.
            countryPlaceholder: "Country / Location",
            countryHint: "Countries listed on the account's profile.",
            creatorOnly: "Verified / Creators Only",
            maxCountryAlert: "You can only select 5 countries.",
            maxTagAlert: "You can only select 10 tags.",
            negativeFollowersAlert: "Followers can't be negative.",
            minMaxAlert: "Min followers can't be greater than max followers.",

            hideFilters: "Hide filters",
            allPlatforms: "All platforms",
            sortRecommended: "Recommended",
            sortRating: "Highest rated",
            sortEngagement: "Best engagement",
            sortPrice: "Lowest price",
            everyone: "Everyone",
            creators: "Creators",
            brands: "Brands",
            verifiedOnly: "Verified",
            hasMediaKit: "Media kit",
            hasRateCard: "Published prices",
            availabilityLabel: "Availability",
            anyAvailability: "Any",
            minEngagement: "Min engagement %",
            budget: "Max budget ($)",
            budgetHint: "Hides creators whose published minimum is above this. Anyone without prices stays in the list.",
            audience: "Reach & prices",
            profileFilters: "Profile",
            results: "{n} results",
            empty: "Nothing matched",
            emptyDesc: "Try a shorter name, or clear a filter or two.",
            startTyping: "Search for an account",
            startTypingDesc: "Or open the filters to browse by platform, reach, price and availability.",
            viewProfile: "Profile",
            mediaKit: "Media kit",
            selfReported: "Reach and engagement figures are reported by the accounts themselves.",
            moreTags: "+{n}",
            safetyTitle: "Before you get in touch",
            safetyBody: "Especially with a well-known name: open the profile, follow the social links and check that the accounts really belong to them.",
            safetyClose: "Got it"
        },
        admin: {
            tabContact: "Contact",
            tabPromo: "Promo Codes",
            tabAddUser: "Add User",
            tabUsers: "Users",
            tabManuelSocial: "Manual Social Requests",
            tabSocials: "Manage Socials",
            tabDisputes: "Disputes",
            tabReports: "Reports",
            tabFinance: "Finance",
            noDisputes: "No disputes right now.",
            noPayouts: "No payout requests.",
            disputeOpen: "Open",
            disputeResolved: "Resolved",
            theBrief: "The brief",
            deliveries: "Deliveries",
            revisions: "Revision requests",
            ruling: "Ruling",
            rulingNotePlaceholder: "Note for both parties (optional)",
            creatorShare: "Creator share",
            awardCreator: "Award to creator",
            refundBrand: "Refund brand",
            splitAmount: "Split",
            confirmRuling: "Confirm this ruling? Stars move immediately and it cannot be undone.",
            replyPlaceholder: "Reply as the platform team…",
            remainingBalance: "Remaining",
            approve: "Approve",
            markPaid: "Mark paid",
            reject: "Reject",
            promoTemplateTitle: "Message Template",
            promoTemplatePlaceholder: "Template (use * as code placeholder)",
            clearBtn: "Clear",
            createPromoTitle: "Create Promo Code",
            promoNamePlaceholder: "Name",
            promoAmountPlaceholder: "Amount",
            addBtn: "Add",
            copied: "Copied!",
            percent: "Percent",
            amount: "Amount",
            verificationRequests: "Verification Requests",
            createUserTitle: "Create User",
            usernamePlaceholder: "Username",
            emailPlaceholder: "Email",
            passwordPlaceholder: "Password",
            refreshBtn: "Refresh",
            usernameLabel: "Username",
            emailLabel: "Email",
            passwordLabel: "Password",
            brandVerified: "Brand Verified",
            creatorVerified: "Creator Verified",
            trial: "Trial",
            starsLabel: "Stars",
            platformLabel: "Platform",
            followersLabel: "Followers",
            botFetch: "Fetch",
            botFetchAll: "Fill all automatically",
            botWorking: "Reading…",
            botRead: "Read",
            botHint: "Reads each profile's public follower count and fills the field in. Approving is still your call.",
            botErrNoPublicCount: "This platform hides the count from logged-out visitors — check it by hand.",
            botErrUnsupported: "No automatic reader for this platform.",
            botErrNotFound: "Profile not found.",
            botErrBlocked: "The platform refused the request — try again later.",
            botErrRateLimited: "Rate limited — try again in a while.",
            botErrNetwork: "Could not reach the platform.",
            botErrUnreadable: "Page loaded, but no follower count could be read.",
            botErrNoUsername: "This request has no username.",
            botErrNotInQueue: "This request is no longer in the queue.",
            botErrRequestFailed: "The lookup request failed.",
            botErrInternal: "The reader hit an unexpected error.",
            botErrUnknown: "Could not read the follower count.",
            linkLabel: "Link",
            enableCoffees: "Enable Coffees",
            enableCoffeesDesc: "Allow your audience to buy you coffees.",
            updateDateLabel: "Update Date",
            acceptBtn: "Accept",
            declineBtn: "Decline",
            updateBtn: "Update",
            deleteBtn: "Delete",
            allUsers: "All Users",
            usersWithStars: "Users with Stars",
            usersWithoutStars: "Users without Stars",
            total: "total",
            userId: "ID",
            userUsername: "Username",
            userEmail: "Email",
            userStars: "Stars",
            thirdParty: "3rd party",
            unauthorizedTitle: "Unauthorized",
            unauthorizedMsg: "You do not have permission to access this page.",
            headerTitle: "Admin"
        },
        chats: {
            processingVid: "Processing video...",
            newMessage: "New Message",
            subOnlyWarning: "This user only accepts messages from people who unlock. You cannot send a message.",
            newMessages: "New Messages",
            newNotif: "new message",
            starsSent: "Stars Sent",
            showPrevious: "Show Previous Messages",
            notEnoughStars: "You do not have enough stars.",
            starErrorMsg: "An error occurred while sending stars.",
            title: "Messages",
            searchPlaceholder: "Search conversations...",
            tabChats: "Chats",
            tabArchived: "Archived",
            tabBlocked: "Blocked",
            archiveBtn: "Archive",
            unarchiveBtn: "Unarchive",
            selectConversation: "Select a conversation",
            unblockBtn: "Unblock",
            blockBtn: "Block",
            uploadingVid: "Uploading video...",
            sending: "Sending",
            sendBtn: "Send",
            selected: "Selected: ",
            sendStars: "Send Stars",
            giftStars: "Gift stars to",
            writeMessage: "Write a message...",
            cancelBtn: "Cancel",
            chooseFile: "Choose File",
            noFileChosen: "No file chosen"
        },
        creator: {
            saveError: "An error occurred while saving preferences.",
            preferences: "Preferences",
            restrictMedia: "Restrict media access",
            restrictMediaDesc: "Only subscribers can view your media content",
            subMessaging: "Subscriber-only messaging",
            subMessagingDesc: "Only subscribers can send you messages",
            brandOnlyMessaging: "Brands only",
            brandOnlyMessagingDesc: "Only brand accounts can message you — keeps your inbox to collaboration offers",
            messagingGatesNote: "Both filters are on. Brands still reach you directly — they are not asked to subscribe first.",
            enableSubs: "Enable subscriptions",
            enableSubsDesc: "Allow users to subscribe to your content",
            subPrice: "Subscription price",
            subPriceDesc: "Name your own monthly price. Subscribers are charged this in USD.",
            perMonth: "/month",
            savePrice: "Save",
            priceSaved: "Price saved",
            priceRange: "Between {min} and {max} per month.",
            priceOutOfRange: "Enter a price between $1 and $5,000.",
            priceRequired: "Set a subscription price before switching subscriptions on.",
            priceLive: "Subscribers are charged {price} per month.",
            subscribers: "Subscribers",
            total: "total",
            noSubs: "No subscribers yet.",
            subscribedOn: "Subscribed",
            active: "Active",
            inactive: "Inactive",
            gallery: "Gallery",
            items: "items",
            uploading: "Uploading...",
            addMedia: "Add Media",
            photo: "Photo",
            video: "Video",
            noMedia: "Upload photos and videos to your gallery.",
            uploadError: "Failed to upload media.",
            deleteError: "Failed to delete media.",
            videoTag: "▶ Video",
            photoTag: "📷 Photo",
            enableCoffees: "Enable Coffees",
            enableCoffeesDesc: "Allow your audience to buy you coffees."
        },
        media: {
            photo: "Photo",
            video: "Video",
            close: "Close",
            next: "Next",
            previous: "Previous",
            openOriginal: "Open original",
        },
        gallery: {
            dropTitle: "Drag media here, or click to choose",
            dropHint: "Photos up to 10 MB · videos up to 10 minutes",
            dropNow: "Drop to upload",
            queued: "Waiting",
            uploading: "Uploading",
            processing: "Processing",
            saving: "Saving",
            processingHint: "Preparing the video for playback",
            failed: "Upload failed",
            cancel: "Cancel",
            dismiss: "Dismiss",
            remove: "Delete",
            confirmRemove: "Delete",
            tooLarge: "Photos must be 10 MB or smaller.",
            tooLong: "Videos must be 10 minutes or shorter.",
            unsupported: "Only photos and videos can be uploaded.",
            keepOpen: "Keep this page open until the upload finishes.",
        },
        accountType: {
            title: "Choose Account Type",
            subtitle: "Select how you want to use the platform",
            creatorTitle: "Content Creator",
            creatorDesc: "Create content, grow your audience and earn money.",
            brandTitle: "Brand",
            brandDesc: "Find creators and manage advertising campaigns.",
            userTitle: "User",
            userDesc: "Discover content and connect with creators.",
            submitBtn: "Continue",
            confirmTitle: "Are you sure?",
            confirmSelected: "Selected type",
            confirmWarning: "You can only change this once. Please choose carefully.",
            confirmCancel: "Go Back",
            confirmBtn: "Confirm"
        },
        finance: {
            coffeesTitle: "Coffees",
            total: "Total",
            received: "Received",
            sent: "Sent",
            noCoffees: "No coffees in this list yet.",
            sentCoffee: "Sent Coffee",
            noMessage: "No message left.",
            anonymous: "Anonymous",

            pageTitle: "Finance",
            pageSubtitle: "Every income stream, fee and payout on one screen.",

            availableBalance: "Available balance",
            pending: "Pending",
            lifetimeNet: "Lifetime net",
            withdrawn: "Withdrawn",
            payoutProgress: "Progress to payout threshold",
            withdrawBtn: "Withdraw",
            minimumNote: "Minimum payout:",
            belowMinimum: "Your balance is below the payout threshold.",
            alreadyPending: "You already have a payout under review.",
            payoutError: "The payout request could not be sent.",
            payoutPending: "Payout under review",
            confirmPayout: "Send request",
            methodBank: "Bank transfer",
            methodWise: "Wise",
            methodPaypal: "PayPal",
            accountPlaceholder: "IBAN / account details",
            payoutHistory: "Payout history",
            payoutStatus_pending: "Under review",
            payoutStatus_approved: "Approved",
            payoutStatus_paid: "Paid",
            payoutStatus_rejected: "Rejected",

            breakdownTitle: "Income breakdown",
            breakdownHint: "Gross earnings less the platform fee, split by source.",
            source: "Source",
            gross: "Gross",
            fee: "Fee",
            net: "Net",
            source_subscription: "Subscriptions",
            source_coffee: "Coffees",
            source_star: "Stars",
            source_campaign: "Campaigns",

            // Momentum, not totals — the ledger already reports the totals.
            goalTitle: "This month",
            goalHint: "The ledger says how much. This says how it is going.",
            goalThisMonth: "earned this month",
            goalLastMonthToDate: "last month, same day",
            goalLastMonthFull: "all of last month",
            goalNoBaseline: "new",
            goalProjection: "month-end projection",
            goalEstimate: "estimate",
            goalInEscrow: "in escrow",
            goalTarget: "Target",
            goalSet: "Set a monthly target",
            goalSave: "Save",
            goalClear: "Remove target",
            goalPlaceholder: "e.g. 2500",
            goalSaveError: "The target could not be saved.",
            goalOnTrack: "On track",
            goalBehind: "Behind pace",
            goalRemaining: "to go:",
            goalReached: "Target reached",
            goalDailyNeeded: "Needed per day:",
            goalDaysLeft: "days left",
            goalPaceMarker: "Where you would be if you were exactly on pace today",
            platformFee: "Platform fee",
            withholding: "Withholding tax",
            payable: "Payable",
            taxNote: "Withholding is an estimate for guidance only and does not replace your own tax filing.",

            trendTitle: "Last 6 months",
            trendHint: "Net income per month.",

            starWallet: "Star wallet",
            onPayout: "on payout",
            starBalance: "Balance",
            starPurposeNote: "Stars are for gifting in chat",
            escrowIncoming: "In escrow for you",
            escrowOutgoing: "Locked by you",

            pendingPaymentsTitle: "Pending payments",
            pendingPaymentsHint: "Money held in escrow that will land once the work is approved."
        },
        report: {
            title: "Report account",
            subtitle: "You are reporting",
            reasonLabel: "What is the problem?",
            reason_spam: "Spam or unsolicited advertising",
            reason_harassment: "Harassment, threats or abuse",
            reason_scam: "Scam or fraud",
            reason_impersonation: "Pretending to be someone else",
            reason_inappropriate: "Inappropriate or explicit content",
            reason_fake_followers: "Fake followers or engagement",
            reason_no_delivery: "Took payment and did not deliver",
            reason_other: "Something else",
            detailLabel: "Tell us what happened",
            detailPlaceholder: "Dates, links, screenshots you can describe — the more specific, the faster we can act.",
            detailRequired: "Please describe the problem.",
            submit: "Submit report",
            cancel: "Cancel",
            close: "Close",
            sent: "Report received",
            sentNote: "Our team reviews every report. We will not tell this account who reported them.",
            alreadyReported: "You already have a report open about this account.",
            cannotReportSelf: "You cannot report your own account.",
            error: "The report could not be sent. Please try again.",
            privacyNote: "Reports are confidential. The reported account is never shown who filed it."
        },
        reports: {
            status_open: "Open",
            status_reviewing: "Reviewing",
            status_resolved: "Action taken",
            status_dismissed: "Dismissed",
            filterOpen: "Open",
            filterReviewing: "Reviewing",
            filterResolved: "Actioned",
            filterDismissed: "Dismissed",
            filterAll: "All",
            searchPlaceholder: "Search by username or wording…",
            empty: "No reports here.",
            by: "reported by",
            deletedUser: "deleted account",
            reportedBadge: "reported",
            reporterSays: "In the reporter's words",
            noDetail: "The reporter left no description.",
            notePlaceholder: "Internal note — what did you do about it?",
            markReviewing: "Start reviewing",
            actionTaken: "Action taken",
            dismiss: "Dismiss",
            reopen: "Reopen",
            ruledBy: "Ruled by",
            actionHint: "Closing a report does not notify either side. Ban or restrict the account separately if needed."
        },
        wallet: {
            cardTitle: "Campaign wallet",
            cardHint: "Money you top up here funds campaigns. It is held for creators when you approve them, and is not withdrawable.",
            spendableBalance: "Campaign wallet",
            spendable: "Spendable",
            locked: "In escrow",
            deposited: "Topped up",
            inEscrow: "In escrow",
            history: "Wallet activity",

            depositBtn: "Add funds",
            depositTitle: "Add funds",
            depositHint: "Top up your campaign wallet with a card. The balance is ready to spend right away.",
            amountLabel: "Amount",
            rangeNote: "Between",
            continueToPayment: "Continue to payment",
            amountToPay: "To pay",
            payNow: "Pay now",
            depositDone: "Payment received",
            newBalance: "New balance",
            close: "Close",

            walletExplain: "This balance is only spent on campaigns. Your creator earnings are withdrawn separately.",
            securityNote: "Card details go straight to Stripe — they never reach our servers.",
            invalidAmount: "Enter a valid amount.",
            amountOutOfRange: "That amount is outside the allowed range.",
            startError: "The payment could not be started. Please try again.",
            noPublishableKey: "Card payments are not configured yet. Please contact support.",
            paymentFailed: "The payment was declined.",
            paymentIncomplete: "The payment was not completed.",
            creditPending: "Payment received. Your balance will update in a moment.",

            kind_deposit: "Card top-up",
            kind_escrow_lock: "Locked in escrow",
            kind_escrow_refund: "Refunded from escrow",
            kind_admin: "Adjustment",

            depositStatus_pending: "Pending",
            depositStatus_succeeded: "Paid",
            depositStatus_failed: "Failed",
            depositStatus_canceled: "Canceled"
        },
        adminFinance: {
            totalOwed: "Owed to creators",
            totalOwedHint: "Settled but not yet paid out",
            openRequests: "Open requests",
            totalPaid: "Paid out to date",
            totalWallet: "Held in wallets",
            totalWalletHint: "Topped up but not yet spent",
            accounts: "Accounts",
            searchPlaceholder: "Search by username or email…",
            filterAll: "All",
            filterRequests: "Awaiting payment",
            filterOwed: "With a balance",
            noAccounts: "No accounts match.",
            requestBadge: "request",
            requestedAmount: "requested",
            inEscrow: "in escrow",
            inWallet: "in wallet",
            joined: "joined",

            tabOverview: "Overview",
            tabLedger: "Ledger",
            tabPayouts: "Payout requests",
            tabWallet: "Wallet",
            tabStars: "Star movements",
            deposits: "Card top-ups",
            walletAdjust: "Adjust wallet by hand",
            walletAdjustHint: "Signed: a negative amount takes money out. Every adjustment is written to the wallet history.",
            walletApply: "Apply",
            walletTooLow: "The wallet does not hold that much.",

            available: "Available",
            settleable: "Settleable",
            settleableHint: "Including any open request",
            feeTaken: "Fee taken",
            deals: "Collaborations",
            description: "Detail",
            state: "State",
            noRows: "Nothing recorded yet.",
            requested: "requested",
            processed: "processed",

            earningStatus_available: "Available",
            earningStatus_pending: "Pending",
            earningStatus_paid: "Paid",

            starKind_gift: "Gift",
            starKind_purchase: "Purchased",
            starKind_escrow_lock: "Locked in escrow",
            starKind_escrow_release: "Released",
            starKind_escrow_refund: "Refunded",
            starKind_payout: "Cashed out",
            starKind_admin: "Admin adjustment",

            manualPayTitle: "I sent the money — close the balance",
            manualPayHint: "Use this once the transfer has actually left your account. The amount is written off the ledger and recorded as a paid payout, so the history still explains itself.",
            openRequest: "Open payout request",
            amountLabel: "Amount sent",
            blankMeansAll: "Leave blank for the full balance",
            methodLabel: "Method",
            noteLabel: "Reference / note",
            notePlaceholder: "e.g. bank transfer ref #8891",
            settleBtn: "Close the balance",
            confirmLine1: "This writes off",
            confirmLine2: "from the creator's balance and records it as paid. It cannot be undone.",
            confirmSettle: "Yes, I sent it",
            balanceClear: "Balance is clear",
            balanceClearHint: "Nothing is owed to this account right now.",
            nothingToSettle: "There is no balance to close.",
            invalidAmount: "Enter an amount between 0 and the settleable balance.",
            resetStars: "Reset stars",
            resetStarsConfirm: "Set this account's star balance to zero?"
        },
        campaigns: {
            pageTitle: "Campaigns",
            pageSubtitle: "Where brands and creators meet.",
            tabShowcase: "Showcase",
            tabMine: "My campaigns",
            tabApplied: "My applications",
            tabDiscover: "Find creators",
            tabForYou: "For you",
            tabCalendar: "Calendar",
            tabContracts: "Contracts",
            newCampaign: "New campaign",

            open: "Open",
            closed: "Closed",
            draft: "Draft",
            applicants: "applicants",
            approved: "approved",
            slots: "slots",
            followers: "followers",
            commission: "commission",
            brandAccount: "Brand",
            netDays: "Net",
            hours: "hours",
            months: "months",
            days: "days",

            searchPlaceholder: "Search campaigns or brands…",
            allPlatforms: "All platforms",
            allPaymentModels: "All payment models",
            openOnly: "Open only",

            emptyShowcase: "No campaigns yet",
            emptyShowcaseDesc: "Try clearing the filters, or check back a little later.",
            emptyMine: "You have not published a campaign yet",
            emptyMineDesc: "Write a brief, set the budget and start receiving applications.",
            emptyApplied: "No applications yet",
            emptyAppliedDesc: "Browse the showcase and apply to campaigns that fit you.",
            browseShowcase: "Browse showcase",

            newTitle: "New campaign",
            editTitle: "Edit campaign",
            formHint: "The clearer the brief, the better the applications.",
            basicsTitle: "Basics",
            basicsHint: "Name, cover and the platforms the work will run on.",
            fieldTitle: "Title",
            titlePlaceholder: "e.g. Summer collection launch",
            fieldSummary: "Short summary",
            summaryPlaceholder: "One line describing the collaboration",
            fieldImages: "Images",
            imagesHint: "Every image is framed 16:9 — the shape used on the campaign card. You choose the crop as you upload.",
            cover: "Cover",
            makeCover: "Make cover",
            fieldPlatforms: "Platforms",
            addPlatform: "Add a platform…",
            platformGroup_social: "Social & short-form",
            platformGroup_live: "Live & community",
            platformGroup_audio: "Audio & music",
            platformGroup_video: "Video",
            platformGroup_writing: "Writing & portfolio",
            platformGroup_commerce: "Support & shops",
            platformGroup_other: "Other channels",

            briefTitle: "Brief",
            briefHint: "Add as many headings as you need; each one shows as a section on the campaign page.",
            customSection: "Custom heading",
            noSections: "No sections yet — start from a preset above.",
            sectionTitlePlaceholder: "Heading",
            sectionBodyPlaceholder: "Write the details for this heading…",
            sectionBrief: "Brief",
            sectionGoal: "Goal",
            sectionKpi: "KPIs",
            sectionTone: "Brand tone & message",
            sectionRestrictions: "Restrictions",
            sectionDeliverables: "Deliverables",
            sectionTimeline: "Timeline",
            sectionRights: "Usage rights",

            deliverablesTitle: "Deliverables",
            deliverablesHint: "Content type, platform and quantity.",
            addDeliverable: "Add deliverable",
            platform: "Platform",
            format: "Format",
            format_reels: "Reels",
            format_story: "Story",
            format_post: "Post",
            format_short: "Short",
            format_video: "Video",
            format_live: "Live",
            format_stream: "Stream",

            kpiTitle: "KPIs",
            kpiHint: "How success will be measured.",
            addKpi: "Add KPI",
            kpiMetricPlaceholder: "e.g. Views",
            kpiTargetPlaceholder: "e.g. 100k",

            budgetTitle: "Budget & payment terms",
            budgetHint: "The fee is taken from your campaign wallet and held in escrow when you approve a creator.",
            payment_fixed: "Fixed fee",
            payment_affiliate: "Affiliate",
            payment_barter: "Barter",
            payment_hybrid: "Hybrid",
            paymentDesc_fixed: "An agreed fee per creator, released once you approve the work.",
            paymentDesc_affiliate: "The creator earns a share of the sales they drive.",
            paymentDesc_barter: "Product or service in exchange for the content — no cash changes hands.",
            paymentDesc_hybrid: "A base fee plus commission and/or product.",
            fieldBudgetUsd: "Budget per creator (USD)",
            escrowNote: "This amount is debited from your campaign wallet and held until approval.",
            fieldCommission: "Commission (%)",
            fieldBarter: "Product / service offered",
            barterPlaceholder: "e.g. 2 pairs of trainers + a €50 voucher",
            fieldPaymentTerms: "Payment terms (days)",
            fieldSlots: "Creators wanted",

            timelineTitle: "Timeline & rules",
            timelineHint: "Dates, revision rounds and the review window.",
            fieldApplicationDeadline: "Application deadline",
            fieldDraftDue: "Draft due",
            fieldPublishDate: "Publish date",
            fieldRevisionLimit: "Free revisions",
            fieldAutoApprove: "Review window (hours)",
            autoApproveNote: "If you do not review within this window the work is approved automatically and the payment is released.",

            rightsTitle: "Usage rights & exclusivity",
            rightsHint: "How long you may reuse the content and whether competitors are off-limits.",
            fieldUsageRights: "Usage rights (months)",
            fieldExclusivity: "Exclusivity (days)",
            fieldExclusivityNote: "Exclusivity note",
            exclusivityPlaceholder: "e.g. no competing sportswear brands for 30 days",

            trackingTitle: "Tracking & targeting",
            trackingHint: "UTM links, discount codes and who may apply.",
            fieldUtm: "UTM link",
            fieldDiscountCode: "Discount code",
            fieldMinFollowers: "Minimum followers",
            fieldTags: "Tags",
            tagPlaceholder: "Add a tag",

            termsTitle: "Terms",
            escrowExplain: "The payment is held by the platform until the work is approved. Neither side can move it on their own — if you disagree, our team arbitrates.",

            cancel: "Cancel",
            saveDraft: "Save draft",
            publish: "Publish",
            preview: "Preview",
            edit: "Edit",
            archive: "Archive",
            archiveConfirm: "Archive this campaign?",
            archiveBlocked: "There are still collaborations holding money — the campaign was paused instead.",
            titleRequired: "A title is required.",
            saveError: "Something went wrong. Please try again.",
            uploadError: "The image could not be uploaded.",

            applyBtn: "Apply",
            applyMessagePlaceholder: "Tell the brand why you are a good fit…",
            sendApplication: "Send application",
            withdrawBtn: "Withdraw",
            yourApplication: "Your application",
            showDetails: "Show details",
            hideDetails: "Hide details",
            openCampaign: "Open the campaign page",
            ownCampaign: "This is your own campaign.",
            creatorsOnly: "Only creator accounts can apply.",
            appStatus_pending: "Pending",
            appStatus_approved: "Approved",
            appStatus_rejected: "Rejected",
            appStatus_withdrawn: "Withdrawn",

            applicantsTitle: "Applicants",
            noApplicants: "No applications yet.",
            newApplications: "new",
            activeCollabs: "Active collaborations",
            escrowAmount: "Escrow",
            approveAndLock: "Approve & lock",
            reject: "Reject",
            insufficientBalance: "Your campaign wallet does not cover this. Add funds first.",
            shortBy: "short by",

            dealStatus_in_progress: "In progress",
            dealStatus_submitted: "Awaiting review",
            dealStatus_revision_requested: "Revision requested",
            dealStatus_disputed: "In dispute",
            dealStatus_completed: "Completed",
            dealStatus_cancelled: "Cancelled",
            escrow_locked: "in escrow",
            escrow_frozen: "frozen",
            escrow_released: "released",
            escrow_refunded: "refunded",
            escrow_split: "split",

            submitWorkTitle: "Submit your work",
            deliveryLinkPlaceholder: "Link to the content (post, video, draft…)",
            deliveryNotePlaceholder: "Notes for the brand (optional)",
            deliveryRequired: "Add a link or attach a file.",
            submitWork: "Deliver work",
            deliveryRound: "Delivery",
            awaitingBrand: "Awaiting the brand's approval",
            timeLeft: "Time left",
            autoApproveDue: "auto-approving",
            autoApproveExplain: "If the brand does not review in time, the work is approved automatically and the payment is released to you.",
            reviewWindow: "Review window",
            approveAndPay: "Approve & pay",
            requestRevision: "Request revision",
            reviewHint: "Approving releases the payment immediately and cannot be undone.",
            awaitingCreator: "Waiting for the creator's delivery.",
            revisionsUsed: "Revisions",
            revisionRequested: "Revision requested",

            revisionTitle: "Request a revision",
            revisionHint: "Pick what does not match the brief. This is what an arbitrator reads if it escalates.",
            revisionNotePlaceholder: "Add detail (optional)",
            revisionReasonRequired: "Pick a reason or describe the problem.",
            sendRevision: "Send request",
            reason_missing_hashtag: "The requested hashtag or link was not used.",
            reason_wrong_mention: "The brand or product was named incorrectly.",
            reason_quality: "Video quality or format is not as requested.",
            reason_brief_mismatch: "The content does not follow the brief.",
            reason_wrong_platform: "Published on the wrong platform or format.",
            reason_late: "Delivered after the agreed date.",
            reason_other: "Other (explained below).",

            raiseDispute: "Raise a dispute",
            disputeLockedHint: "Disputes open once the free revision rounds are used up.",
            disputeFormTitle: "Why are you escalating?",
            disputeReasonPlaceholder: "Explain the problem for the arbitrator…",
            startDispute: "Start dispute",
            disputeSuspended: "This campaign is suspended",
            disputeLocked: "Locked amount",
            disputeResolved: "Ruling",
            resolution_creator: "Payment awarded to the creator.",
            resolution_brand: "Payment refunded to the brand.",
            resolution_split: "Payment split between both parties.",
            evidenceTitle: "Evidence",
            evidencePlaceholder: "Write your explanation…",
            evidenceHint: "Only the two parties and the platform team can see this thread.",
            platformTeam: "Platform team",
            send: "Send",
            dealCompleted: "Collaboration completed",
            dealCancelled: "Collaboration cancelled",
            creatorGot: "Creator",
            brandGot: "Brand",

            proposedPrice: "Your price",
            brandBudget: "Brand's budget",
            useProposed: "Use the price asked for:",
            noRateCardHint: "You have not published a rate card yet. Adding one on the creator page lets you quote with a single tap."
        },

        // Media kit — the press page a creator publishes instead of mailing
        // a PDF around.
        mediaKit: {
            title: "Media kit",
            pageTitle: "Media kit",
            subtitle: "One shareable page with your reach, audience and past work — no PDF needed.",
            statusPublished: "Published",
            statusDraft: "Draft",

            reach: "reach",
            engagement: "engagement",
            engagementShort: "eng.",
            completedDeals: "completed jobs",
            views: "views",

            completeness: "How complete it is",
            checkHeadline: "Write a one-line introduction",
            checkBio: "Describe what you do",
            checkReach: "Enter reach and engagement",
            checkAudience: "Add the audience breakdown",
            checkSamples: "Pick sample content",
            checkCollabs: "List past collaborations",
            checkRates: "Publish your prices",

            autoAttachNote: "Your media kit is attached to every campaign application automatically — the brand sees it without asking.",
            createBtn: "Create media kit",
            editBtn: "Edit media kit",
            previewBtn: "Preview",
            publishBtn: "Publish",
            unpublishBtn: "Unpublish",
            showOnProfile: "Show on my profile",
            showOnProfileHint: "Turn this off and the page stays live — brands reading your applications still get it, your profile just stops advertising it.",

            editTitle: "Media kit",
            editHint: "Everything here is what a brand reads before deciding.",
            creatorsOnly: "Only creator accounts can publish a media kit.",
            saveDraft: "Save as draft",
            publish: "Save and publish",

            identityTitle: "Introduction",
            identityHint: "The first three lines a brand reads.",
            fieldHeadline: "One-line introduction",
            headlinePlaceholder: "Fashion & lifestyle creator, Istanbul",
            fieldBio: "About you",
            bioPlaceholder: "Who you make content for, and what you are good at…",
            fieldLocation: "Location",
            locationPlaceholder: "Istanbul, TR",
            fieldContactEmail: "Contact email",
            fieldLanguages: "Languages",
            languagePlaceholder: "English",
            fieldCover: "Cover image",
            coverHint: "Crop it to the banner at the top of your page — what you frame here is what gets published.",
            coverCropTitle: "Position your cover",
            replaceCover: "Change cover",
            removeCover: "Remove cover",

            performanceTitle: "Reach & engagement",
            performanceHint: "The numbers that decide a collaboration. Follower counts are already on file — these are what a post actually does.",
            avgReach: "Avg. reach",
            avgViews: "Avg. views",
            engagementRate: "Engagement %",
            noSocials: "Add a social account to your profile first — the figures are entered per account.",
            selfReportedWarning: "These are your own figures. Enter them as your analytics screen shows them — a brand that finds them inflated will not work with you twice.",
            selfReportedNote: "Reach, engagement and audience figures are reported by the creator. Completed jobs are counted by the platform.",
            selfReportedShort: "Reported by the creator",

            audienceTitle: "Audience",
            audienceHint: "Who actually sees your content. Copy it from your analytics screen.",
            audienceCountries: "Countries",
            audienceAge: "Age",
            audienceGender: "Gender",
            countryPlaceholder: "Country",
            agePlaceholder: "Age range",
            genderPlaceholder: "e.g. Women",
            splitTotal: "Total",
            addRow: "Add row",

            highlightsTitle: "Highlights",
            highlightsHint: "Two or three numbers you want seen first.",
            highlightLabelPlaceholder: "Avg. views",
            highlightValuePlaceholder: "180K",

            collabsTitle: "Past collaborations",
            otherCollabsTitle: "Other collaborations",
            collabsHint: "Work done off the platform. Jobs completed here are listed separately and marked verified.",
            collabBrandPlaceholder: "Brand",
            collabNotePlaceholder: "What you made",
            collabYearPlaceholder: "Year",
            addCollab: "Add collaboration",
            verifiedCollabs: "collaborations completed through the platform",
            verifiedCollabsDesc: "These went through our escrow, so they are shown as verified rather than as a claim.",
            showPlatformDeals: "Show them on my media kit",
            verifiedBadge: "VERIFIED",

            samplesTitle: "Sample content",
            samplesHint: "Pick from your gallery, or link to work that lives on the platforms.",
            noGallery: "Your gallery is empty — you can still add links below.",
            addSampleLink: "Add link",
            viewsPlaceholder: "Views",
            rateCardHint: "Prices appear both on your media kit and on your profile.",

            shareTitle: "Private link",
            shareHint: "Send the page to a single brand before publishing it to everyone.",
            copy: "Copy",
            copied: "Copied",
            share: "Share",
            rotateToken: "Generate a new link",
            rotateTokenHint: "Every link you have shared so far stops working.",

            platformsTitle: "Accounts",
            viewProfile: "View profile",
            updatedAt: "Updated",
            openFullPage: "Open the full media kit",
            attachedShort: "Media kit attached",
            profileCtaDesc: "Reach, audience and past work",

            ownerDraftBanner: "This page is a draft — only you and anyone holding your private link can see it.",
            notPublished: "This media kit is not published",
            notPublishedDesc: "The creator has not shared this page publicly yet.",
            goToProfile: "Go to profile"
        },

        // Rate card — published prices, the other side of a campaign budget.
        rateCard: {
            title: "Rate card",
            subtitle: "Publish your prices so the negotiation does not start from scratch in the DMs.",
            published: "Published",
            publishedDesc: "Visible on your profile, your media kit and every application you file.",
            draft: "Draft",
            draftDesc: "Only you can see it. Turn it on to publish.",

            from: "from",
            packageTag: "Package",
            minBudget: "Min. budget",
            barterOk: "Barter considered",
            openToOffers: "Open to offers",
            turnaround: "Delivery",
            revisionsIncluded: "Revisions",

            addItem: "Add a line",
            noItems: "No priced lines yet.",
            itemTitlePlaceholder: "Instagram Reels",
            itemDescPlaceholder: "What is included (optional)",
            includesPlaceholder: "1× Reels, 3× Story  (comma separated)",
            isPackage: "Package",
            lineActive: "Visible",
            titleRequired: "Every line needs a name.",
            creatorsOnly: "Only creator accounts can publish a rate card.",

            minBudgetLabel: "Minimum budget",
            minBudgetHint: "Applications below this are filtered out before they reach you.",
            acceptsBarter: "I consider barter",
            openToOffersLabel: "I am open to offers",
            notePlaceholder: "e.g. prices do not include exclusivity",

            saveBtn: "Save rate card",
            savedBtn: "Saved"
        },


        // ── Reputation: the two-way rating ──────────────────────────────
        reputation: {
            title: "Track record",
            reviews: "reviews",
            brandHint: "How this brand has behaved in collaborations that settled through the platform.",
            creatorHint: "How this creator has delivered in collaborations that settled through the platform.",
            emptyNote: "No completed collaborations on the platform yet.",
            wouldWorkAgain: "would work with them again",

            criterion_on_time: "Delivered on time",
            criterion_quality: "Content quality",
            criterion_communication: "Communication",
            criterion_brief_fit: "Followed the brief",
            criterion_paid_on_time: "Paid on time",
            criterion_brief_clarity: "Clear brief",
            criterion_fair_review: "Fair review",

            factsTitle: "Platform records",
            factsHint: "Taken from the escrow timeline, not self-reported \u2014 neither side can edit these.",
            factDeals: "Collaborations",
            factReviewedInTime: "Reviewed in time",
            factReviewSpeed: "Avg. review time",
            factOnTime: "Hit the deadline",
            factTurnaround: "Avg. turnaround",
            factDisputes: "Disputes",
            lapsedWarning: "delivery/deliveries were left unanswered until the review window ran out.",

            panelTitle: "Rate this collaboration",
            panelTitleDone: "Your rating",
            panelHint: "Both ratings stay hidden until you have both filed.",
            todo: "To do",
            yourRating: "You said",
            theirRating: "They said",
            bothIn: "Both ratings are in",
            awaitingThem: "They have not rated yet",
            theirsSealed: "Their rating is sealed",
            theirsSealedNote: "They have already rated you. It unseals as soon as you file yours.",
            overallQuestion: "Overall, how was working with",
            wouldWorkAgainQuestion: "I would work with them again",
            commentPlaceholder: "What went well, what did not? (optional)",
            commentPlaceholderRequired: "Say what went wrong \u2014 this is required for a low score.",
            commentRequired: "Say what went wrong. A low score with no reason cannot be answered or acted on.",
            commentRequiredHint: "A score of 1 or 2 needs an explanation before it can be published.",
            pickOverall: "Pick an overall score.",
            submitBtn: "Submit rating",
            updateBtn: "Update rating",
            sealed: "Sealed",
            editableWhileSealed: "You can still change this until it is published.",
            blindNote: "Ratings stay sealed until both sides file, or for {days} days after the collaboration closes.",
            alreadyPublished: "This rating is already public and can no longer be changed.",
            windowClosed: "The rating window for this collaboration has closed.",

            pendingTitle: "Collaborations to rate",
            pendingHint: "Rating a brand that paid on time is how the next creator finds out.",
            rateBtn: "Rate"
        },

        // ── The collaboration agreement ─────────────────────────────────
        contract: {
            title: "Collaboration agreement",
            signed: "Signed",
            frozenNote: "These terms were frozen when escrow closed. Later edits to the campaign do not change this document.",
            brand: "Brand",
            creator: "Creator",
            amount: "Agreed fee",
            fee: "Platform commission",
            net: "Net to creator",
            draftDue: "Draft due",
            publishDate: "Publish date",
            usageRights: "Usage rights",
            exclusivity: "Exclusivity",
            exclusivityNote: "Exclusivity scope",
            revisionLimit: "Free revisions",
            acceptBtn: "Accept",
            awaiting: "Awaiting acceptance",
            digest: "Digest",
            downloadBtn: "Download PDF",
            downloadError: "The document could not be downloaded.",
            loadError: "The agreement could not be loaded."
        },

        // ── Contracts drawer ────────────────────────────────────────────
        contracts: {
            hint: "Every agreement you are a party to. Download the signed PDF of any collaboration, however long ago it closed.",
            searchPlaceholder: "Search by brand, creator or campaign",
            state_all: "All",
            state_open: "Ongoing",
            state_closed: "Closed",
            role_any: "Both sides",
            role_brand: "As brand",
            role_creator: "As creator",
            needsYou: "Needs your signature",
            needsYouBanner: "agreements are waiting for your signature.",
            view: "Details",
            hide: "Close",
            empty: "No agreements yet",
            emptyDesc: "An agreement is issued the moment a collaboration is approved and the payment goes into escrow. Yours will appear here.",
            emptyFiltered: "Nothing matches",
            emptyFilteredDesc: "No agreement matches this search. Try a different name or clear the filters."
        },

        // ── Calendar ────────────────────────────────────────────────────
        calendar: {
            view_agenda: "Agenda",
            view_month: "Month",
            type_draft_due: "Draft due",
            type_publish: "Publish",
            type_review_deadline: "Review deadline",
            type_application_deadline: "Applications close",
            type_application_pending: "Application pending",
            planned: "planned",
            urgency_overdue: "Overdue",
            urgency_today: "Today",
            urgency_soon: "This week",
            urgency_upcoming: "Upcoming",
            urgency_done: "Done",
            overdueTitle: "Overdue",
            upcomingTitle: "Coming up",
            doneTitle: "Completed",
            empty: "Nothing scheduled",
            emptyDesc: "Draft and publish dates from your collaborations show up here automatically.",
            weekday_0: "Mon",
            weekday_1: "Tue",
            weekday_2: "Wed",
            weekday_3: "Thu",
            weekday_4: "Fri",
            weekday_5: "Sat",
            weekday_6: "Sun"
        },

        // ── Availability: the creator saying they want work ─────────────
        availability: {
            title: "Availability",
            hint: "Tell brands whether you are taking work. This is what puts you in front of a brand that has not searched for you yet.",
            statusLabel: "Right now I am",
            status_none: "Not stated",
            status_open: "Open to work",
            status_limited: "Limited",
            status_busy: "Booked out",
            status_closed: "Not taking work",
            statusDesc_none: "Nothing about availability appears on your profile",
            statusDesc_open: "Taking on new collaborations",
            statusDesc_limited: "Room for one or two more",
            statusDesc_busy: "Full, but pitchable for later",
            statusDesc_closed: "Hidden from recommendations",
            availableFrom: "Free again from",
            availableFromDesc: "\"Back on the 12th\" is a far more useful answer than a flat no.",
            openToWork: "Open to work",
            openToWorkLabel: "Show the \"open to work\" badge",
            openToWorkDesc: "A green badge on your profile, your press page and every applicant row.",
            notePlaceholder: "One line brands should know (e.g. taking bookings for October)",
            categoriesLabel: "What you work on",
            categoriesDesc: "Used to match you to briefs. The closer these are to how a brand describes its campaign, the higher you rank.",
            categoriesPlaceholder: "e.g. beauty, travel, gaming",
            platformsLabel: "Platforms you want work on",
            discoverableLabel: "Appear in recommendations",
            discoverableDesc: "Turn this off to keep your profile public but stay out of the brand-facing lists.",
            save: "Save availability",
            saved: "Saved"
        },

        // ── Discovery: creators found rather than searched for ──────────
        discover: {
            searchPlaceholder: "Search creators\u2026",
            budget: "Budget",
            budgetHint: "Creators whose published prices fit this budget rank higher; anyone whose minimum is above it is flagged.",
            match: "Match",
            reach: "reach",
            engagement: "engagement",
            from: "from",
            viewKit: "Media kit",
            contact: "Contact",
            empty: "No creators found",
            emptyDesc: "Loosen the filters, or drop the budget requirement to see everyone.",

            reason_platform: "Posts on ",
            reason_category: "Works on ",
            reason_country: "Audience in ",
            reason_budget_fit: "Fits your budget \u00b7 from ",
            reason_over_budget: "Minimum above your budget \u00b7 ",
            reason_open_to_offers: "Open to offers",
            reason_open_to_work: "Looking for work",
            reason_free_from: "Free from ",
            reason_rating: "Rated ",
            reason_brand_rating: "Brand rated ",
            reason_fresh_stats: "Recently updated figures",

            suggestTitle: "Suggested creators",
            suggestHint: "Matched to this brief \u2014 platforms, tags, budget",
            suggestEmpty: "Nobody clears the bar for this brief yet. Widening the platforms or the budget usually helps.",

            forYouHint: "Open campaigns matched to the platforms, categories and prices you have already published.",
            forYouEmpty: "No matches yet",
            forYouEmptyDesc: "Add your platforms and categories under Availability, and publish a rate card \u2014 that is what the matching reads."
        },

        // Delivery templates — the note a creator stops retyping.
        templates: {
            label: "Templates",
            manage: "Manage",
            done: "Done",
            edit: "Edit",
            saveThis: "Save this note",
            newTemplate: "New template",
            emptyHint: "Save a delivery note once and reuse it on every hand-off.",
            namePlaceholder: "Template name (e.g. Reels delivery)",
            notePlaceholder: "The note you send with a delivery…",
            checklistPlaceholder: "Checklist: hashtag added, brand tagged  (comma separated)",
            nameRequired: "Give the template a name.",
            emptyTemplate: "Write a note or a checklist — an empty template saves nobody any typing.",
            limitReached: "You have reached the template limit.",
            saveBtn: "Save"
        },

        // The crop-before-upload sheet (components/ImageCropModal.jsx).
        imageCrop: {
            title: "Position the image",
            hint: "Drag to move, use the slider to zoom. Whatever is inside the frame is what gets published.",
            zoom: "Zoom",
            save: "Use this image",
            cancel: "Cancel",
            skip: "Skip this one",
            uploading: "Uploading…",
            preparing: "Preparing…",
            error: "This file could not be opened."
        }
    },
    tr: {
        tab: {
            newMessage: "💬 Yeni mesaj!",
            newMessageBody: "Astreona'da yeni bir mesajınız var.",
            enableTitle: "Masaüstü bildirimleri",
            enableDesc: "Bu sekme arka plandayken mesaj geldiğinde bildirim alın.",
            enableBtn: "Bildirimleri aç",
            enabled: "Bildirimler açık",
            blocked: "Bildirimler tarayıcı ayarlarınızda engellenmiş.",
            unsupported: "Tarayıcınız masaüstü bildirimlerini desteklemiyor."
        },
        notfound: {
            title: "Kaybolmuş gibi görünüyorsunuz",
            desc: "Aradığınız sayfa mevcut değil!",
            home: "Ana Sayfaya Git"
        },
        landing: {
            login: "Giriş Yap",
            signup: "Kaydol",
            badge: "GÜVENLİ MESAJLAŞMA",
            heading1: "Şifreli.",
            heading2: "Anonim.",
            heading3: "Bot İçermez.",
            sub1: "Güvenle Bağlan.",
            sub2: "Özgürce Paylaş.",
            pill1: "🔒 Uçtan Uca Şifreli",
            pill2: "🕶️ Anonim Kimlik",
            pill3: "🤖 Bot Yok"
        },
        login: {
            back: "Geri",
            title: "Hesabınıza giriş yapın",
            usernameLabel: "Kullanıcı Adı veya E-posta",
            usernamePlaceholder: "Kullanıcı Adı",
            passwordLabel: "Şifre",
            passwordPlaceholder: "Şifre",
            submit: "Giriş Yap",
            forgot: "Şifremi unuttum?",
            or: "veya",
            google: "Google ile Giriş Yap",
            errorAlert: "Bir hata oluştu. Lütfen tekrar deneyin."
        },
        register: {
            back: "Geri",
            title: "Kaydol",
            usernameLabel: "Kullanıcı Adı",
            usernamePlaceholder: "Kullanıcı Adı",
            emailLabel: "E-posta adresi",
            emailPlaceholder: "E-posta",
            passwordLabel: "Şifre",
            passwordPlaceholder: "Şifre",
            noSpaces: "Şifre boşluk içeremez",
            confirmLabel: "Şifre onayı",
            confirmPlaceholder: "Şifreyi onayla",
            codePlaceholder: "6 haneli kodu girin",
            resend: "Tekrar Gönder",
            spamNote: "Spam klasörünü kontrol edin ve spam değil olarak işaretleyin.",
            submit: "Kaydol",
            terms: "Kaydol butonuna tıklayarak",
            termsLink: "kullanım koşullarını",
            and: "ve",
            privacyLink: "gizlilik politikasını",
            termsEnd: " kabul etmiş olursunuz.",
            or: "veya",
            google: "Google ile Kaydol",
            error: "Bir şeyler ters gitti!",
            codeSent: "kod gönderildi"
        },
        forget: {
            title0: "Hesabınızı Bulun",
            desc0: "Hesabınızla ilişkili e-posta adresini veya kullanıcı adını girin.",
            label0: "E-posta adresi veya kullanıcı adı",
            submit: "Gönder",
            title1: "Onay Kodu Gönder",
            desc1: "Şifrenizi değiştirmeden önce kimliğinizi doğrulamamız gerekiyor.",
            sendEmail: "E-posta gönder: ",
            title2: "Size Bir Kod Gönderdik",
            desc2: "Doğrulama kodunu alıp almadığınızı kontrol edin. Yeni bir tane istemek için geri gidin.",
            label2: "Kodu Girin",
            placeholder2: "Kodu Girin",
            spamNote: "Spam klasörünü kontrol edin ve spam değil olarak işaretleyin.",
            back: "Geri",
            title3: "Yeni Şifre Seçin",
            desc3: "Yeni şifrenizin 8 veya daha fazla karakter uzunluğunda olduğundan emin olun.",
            newPlaceholder: "Yeni şifre",
            confirmPlaceholder: "Şifreyi onayla",
            noSpaces: "Şifre boşluk içeremez"
        },
        nav: {
            payAlert: "Bu özelliği kullanmak için ödeme yapmalısınız. Lütfen Ayarlar → Ödemeler'e gidin"
        },
        settings: {
            title: "Ayarlar",
            tabAccount: "Hesap",
            tabPayments: "Erişim",
            tabContact: "Bize Ulaşın - Yardım Merkezi - İstek ve öneriler",
            spoken: "Konuşulan",
            stars: "Starlar",
            spokenInfo: "Bu sayaç, mesaj attığınız toplam kişi sayısını izler.",
            subsTitle: "Kilidi Açılanlar",
            subsTotal: "toplam",
            subsEmpty: "Henüz kilidi açılan içerik üretici yok.",
            subsStarted: "Başlangıç",
            subsCancelsAtEnd: "",
            // Dönem sonunda iptal edilecek
            subsEnded: "Sona erdi",
            subsStatusEnded: "Sona erdi",
            subsStatusCanceling: "İptal ediliyor",
            subsStatusActive: "Aktif",
            subsStatusInactive: "Pasif",
            subsExpired: "Süresi dolmuş",
            subsReactivate: "Yeniden etkinleştir",
            subsCancel: "Takipten çık"
            // İptal et
        },
        account: {
            generalInfo: "Genel Bilgiler",
            accountOpened: "Hesap açılış tarihi:",
            changeName: "İsmi Değiştir",
            usernamePlaceholder: "kullanıcı adı",
            nameChanged: "isim değiştirildi",
            usernameExists: "Bu kullanıcı adı zaten alınmış.",
            saveBtn: "Kaydet",
            emailTitle: "E-posta",
            changeBtn: "Değiştir",
            addBtn: "Ekle",
            changeEmailTitle: "E-postayı Değiştir",
            newEmailPlaceholder: "Yeni e-posta adresini girin",
            usingThisEmail: "bu e-postayı kullanıyorsunuz",
            codeSent: "kod gönderildi",
            codeNotSent: "Bu adrese kod gönderemedik. Lütfen adresi kontrol edip tekrar deneyin.",
            enterCodePlaceholder: "Kodu girin",
            resendBtn: "Tekrar Gönder",
            checkSpam: "Spam klasörünü kontrol edin ve spam değil olarak işaretleyin.",
            submitBtn: "Gönder",
            closeBtn: "Kapat",
            passwordTitle: "Şifre",
            changePasswordBtn: "Şifreyi Değiştir",
            changePasswordTitle: "Şifreyi Değiştir",
            currentPasswordPlaceholder: "Mevcut şifre",
            forgotPasswordLabel: "Şifremi unuttum?",
            newPasswordPlaceholder: "Yeni şifre",
            confirmPasswordPlaceholder: "Şifreyi onayla",
            terminateSessions: "Şifrenizi değiştirdiğinizde diğer oturumlar sonlandırılacaktır.",
            logoutBtn: "Çıkış Yap",
            deleteAccountBtn: "Hesabı Sil",
            confirmDelete: "Onaylamak için lütfen",
            confirmDeleteSuffix: "yazın",
            activeSubAlert: "Aktif bir aboneliğiniz var. Lütfen önce aboneliğinizi iptal edin.",
            cancelBtn: "İptal",
            manageSubBtn: "Aboneliği Yönet",
            deleteBtn: "Sil",
            passwordSameAlert: "yeni şifre eski şifre ile aynı olamaz",
            passwordsNotMatch: "şifreler eşleşmiyor",
            passwordChanged: "şifre değiştirildi"
        },
        payments: {
            errorPortal: "Müşteri portalına yönlendirilirken hata oluştu",
            promoInvalid: "Promosyon Kodu geçerli değil.",
            subscribeTitle: "Deneme süresi sona erdi.",
            subscribeDesc: "Erişim sağlamak için lütfen giriş ücretini ödeyin.",
            payNowBtn: "Hemen abone ol",
            promoTitle: "Promosyon Kodu",
            promoPlaceholder: "Promosyon kodunu girin",
            applyCodeBtn: "Kodu Uygula",
            lifetimePromo: "Ömür boyu geçerli bir promosyon kodunuz var",
            manageSubTitle: "Aboneliği Yönet",
            manageSubBtn: "Aboneliği Yönet",
            subDetailsTitle: "Abonelik Detayları",
            startedAt: "Başlangıç tarihi",
            cancelAt: "İptal edilecek tarih",
            canceledAt: "İptal edilme tarihi",
            status: "Durum",
            buyStarsTitle: "Star Satın Al",
            buyStarsDesc: "Yeni insanlara mesaj atmak için daha fazla star alın",
            starAmountLabel: "Kaç yıldız almak istiyorsunuz?",
            starRate: "1 ★ = 1 $",
            starTotal: "Toplam",
            buyStarsBtn: "Ödemeye geç",
            starCheckoutNote: "Ödeme kartınızla burada alınır. Yıldızlar ödeme onaylanır onaylanmaz bakiyenize eklenir.",
            starSheetHint: "{count} yıldız",
            starsAdded: "{count} yıldız eklendi",
            starsAddedDetail: "Bakiyenizde, göndermeye hazır.",
            mostPopular: "En Popüler",
            bestValue: "En İyi Değer",
            newMessagesAlert: "Yeni mesajlarınız var",

            // Aboneliğin yönetimi artık tamamen uygulama içinde; eskiden burada
            // Stripe müşteri portalına götüren tek bir düğme vardı.
            updateCardBtn: "Kartı güncelle",
            updateCardTitle: "Ödeme yöntemi",
            updateCardHint: "Yeni kart bir sonraki yenilemede kullanılır.",
            cardUpdated: "Kart güncellendi",
            cardUpdatedDetail: "Bir sonraki yenileme yeni kartla yapılacak.",
            cancelSubBtn: "Aboneliği iptal et",
            cancelSubConfirmBtn: "Evet, iptal et",
            cancelConfirm: "Aboneliğiniz ödediğiniz dönemin sonuna kadar açık kalır, sonrasında yenilenmez.",
            reactivateBtn: "Aboneliği sürdür",
            willCancelNote: "Bu abonelik mevcut dönemin sonunda duracak şekilde ayarlandı."
        },

        // `api/UserData/` hiç yüklenemediğinde gösterilir.
        session: {
            title: "Hesabınız yüklenemedi",
            desc: "Sunucu yanıt vermedi. Bağlantınızı kontrol edip tekrar deneyin.",
            retry: "Tekrar dene",
        },

        // Uygulamadaki tüm ödeme ekranlarının paylaştığı metinler.
        billing: {
            payNow: "Ödemeyi yap",
            cancel: "Vazgeç",
            close: "Kapat",
            continue: "Devam et",
            retry: "Tekrar dene",
            amountToPay: "Ödenecek",
            perMonth: "Aylık",
            perMonthShort: "/ay",
            securityNote: "Kart bilgileri doğrudan Stripe'a gider — sunucularımıza hiç uğramaz.",
            recurringNote: "Her ay yenilenir. İstediğiniz zaman iptal edebilirsiniz.",
            subscribeNow: "Kilidini Aç",
            subscribeHint: "Ödeme burada alınır — başka bir siteye yönlendirilmezsiniz.",
            subscribeToTitle: "{name} aboneliği",
            creatorTerms: "{name} için ayda {price}, siz iptal edene kadar.",
            subscribedTitle: "Abone oldunuz",
            subscribedDetail: "Aboneliğiniz aktif.",
            subscribedToCreator: "Artık {name} hesabına abonesiniz.",
            subscriptionPending: "Ödeme alındı. Abonelik birkaç saniye içinde aktif görünecek.",
            paymentFailed: "Ödeme reddedildi.",
            paymentIncomplete: "Ödeme tamamlanmadı.",
            paymentProcessing: "Ödeme işleniyor. Bu biraz sürebilir.",
            startError: "Ödeme başlatılamadı. Lütfen tekrar deneyin.",
            noPublishableKey: "Kartla ödeme henüz yapılandırılmamış. Lütfen destek ile iletişime geçin.",
            invalidAmount: "Geçerli bir tutar girin.",
            cardUpdateFailed: "Kart kaydedildi ama uygulanamadı. Lütfen tekrar deneyin.",
            alreadySubscribed: "Zaten aktif bir aboneliğiniz var.",
            planUnavailable: "Abonelikler geçici olarak kullanılamıyor. Lütfen daha sonra deneyin.",
            noPriceSet: "Bu üretici henüz bir abonelik ücreti belirlemedi.",
            subscriptionsClosed: "Bu üretici şu anda abonelik almıyor.",
            notACreator: "Bu hesap abonelik sunmuyor.",
            selfSubscription: "Kendinize abone olamazsınız.",
            notFound: "Bulunamadı."
        },
        contact: {
            title: "Bize Ulaşın",
            desc: "Sorularınız mı var ya da yardıma mı ihtiyacınız var? Buradayız! Bize istediğiniz zaman ulaşın.",
            nameLabel: "Adınız",
            namePlaceholder: "Adınızı girin",
            emailLabel: "E-posta Adresi",
            emailPlaceholder: "E-postanızı girin",
            subjectLabel: "Konu",
            subjectPlaceholder: "Konuyu girin",
            messageLabel: "Mesaj",
            messagePlaceholder: "Mesajınızı buraya yazın...",
            sendBtn: "Mesaj Gönder",
            successMsg: "Mesajınız alındı."
        },
        profile: {
            errorMsg: "Hata oluştu, lütfen sayfayı yenileyin",
            addLinkBtn: "Bağlantı Ekle",
            addLinkTitle: "Bağlantı Ekle",
            addLinkHint: "Herhangi bir web sitesi. Tanınan platformlar kendi ikonuyla görünür.",
            addSocialMediaHint: "Önce platformu, sonra oradaki kullanıcı adını seçin.",
            linkDetected: "Tanındı",
            linkGeneric: "Web sitesi",
            useDetectedTitle: "Kullan:",
            linkIsSocialTitle: "{platform} sosyal hesaplarınıza ait",
            linkIsSocialBody: "Sadece bağlantı olarak eklenirse aramada ve marka keşfinde çıkmaz. Sosyal medya hesabı olarak ekleyin ki takipçi sayınız doğrulansın ve markalar sizi bulabilsin.",
            linkIsSocialAction: "Sosyal medya olarak ekle",
            linkIsSocialBadge: "Aramada çıkmaz",
            deleteBtn: "Kaldır",
            backgroundTitle: "Profil arka planı",
            backgroundHint: "Profil kartınızın arkasındaki renk.",
            linkUrlPlaceholder: "Bağlantı URL'si",
            titlePlaceholder: "Başlık",
            submitBtn: "Gönder",
            closeBtn: "Kapat",
            changePhotoBtn: "Fotoğraf Değiştir",
            zoomLabel: "Yakınlaştır",
            saveBtn: "Kaydet",
            editProfileBtn: "Profili Düzenle",
            deletePhotoBtn: "Fotoğrafı Sil",
            updateCoverPhoto: "Kapak Fotoğrafını Güncelle",
            enableCoffees: "Kahve ısmarlamasına izin ver",
            enableCoffeesDesc: "Kullanıcıların size kahve ısmarlamasına izin verin.",
            bioTextLabel: "Hakkımda",
            bioPlaceholder: "Biyografi",
            bioHelp: "Kısa ve anlaşılır tutun.",
            visibleBtn: "Görünür",
            visibleHelp: "Hesabınız görünür. Gizlemek için tıklayın.",
            hiddenBtn: "Gizli",
            hiddenHelp: "Hesabınız gizli. Görünür yapmak için tıklayın.",
            selectColor: "Renk Seçin",
            hex: "Hex",
            rgb: "RGB",
            saveColorBtn: "Rengi Kaydet",
            thumbAdd: "Küçük görsel ekle",
            thumbReplace: "Küçük görseli değiştir",
            thumbRemove: "Küçük görseli kaldır",
            thumbCropTitle: "Bağlantı görseli",
            thumbCropHint: "Kare; satırın başında görünür.",
            thumbUploadError: "Görsel yüklenemedi. Lütfen tekrar deneyin.",
            thumbSaveError: "Küçük görsel kaydedilemedi. Lütfen tekrar deneyin.",
            viewBtn: "Görüntüle",
            creatorToggleLabel: "İçerik Üreticisi",
            creatorToggleHelp: "Profilinizde içerik üreticisi özelliklerini etkinleştirin.",
            verifiedBrand: "Doğrulanmış İşletme",
            verifiedCreator: "Doğrulanmış İçerik Üretici",
            unverifiedBrand: "İşletme (Doğrulanmamış)",
            unverifiedCreator: "İçerik Üretici (Doğrulanmamış)",
            addSocialMediaBtn: "Sosyal Medya Ekle",
            addSocialMediaTitle: "Sosyal Medya Ekle",
            platformSelect: "Platform Seçin",
            socialMediaUsernamePlaceholder: "Kullanıcı Adı (örn: ali_veli)",
            platformError: "Lütfen bir platform seçin.",
            usernameError: "Lütfen bir kullanıcı adı girin.",
            inVerification: "Doğrulama sürecinde:",
            followers: "Takipçi:",
            approvalWarning: "Sosyal medya hesabınız kısa sürede onaylanacaktır. Bir hata olduğunu düşünüyorsanız bizimle iletişime geçin.",
            linkCopyWarning: "Sosyal medya hesaplarınızı doğrulayabilmemiz ve diğer kullanıcıların sizi bulabilmesi için, sosyal medya hesabınızın biyografi veya link kısımlarında linkinizi belirtmelisiniz.",
            copyBtn: "Kopyala",
            copiedBtn: "Kopyalandı!",
            tagsLabel: "Profil Etiketleri",
            tagPlaceholder: "Bir etiket ekleyin...",
            addTagBtn: "Ekle",
            locationsLabel: "Topluluk Konumları",
            locationPlaceholder: "Bir konum seçin...",
            requestVerification: "Doğrulama Talep Et",
            verificationRequested: "Doğrulama Talep Edildi"
        },
        theme: {
            title: "Görünüm",
            subtitle: "Herkese açık profilinizin ziyaretçilere nasıl göründüğü.",
            save: "Yayınla",
            saveError: "Kaydedilemedi. Lütfen tekrar deneyin.",
            uploadError: "Görsel yüklenemedi. Lütfen tekrar deneyin.",
            uploading: "Yükleniyor…",
            remove: "Kaldır",

            tabPresets: "Şablonlar",
            tabBackground: "Arka plan",
            tabCard: "Kart",
            tabText: "Yazı",
            tabButtons: "Butonlar",

            presetsHint: "Bir başlangıç noktası seçin, sonra dilediğinizi değiştirin. Yüklediğiniz arka plan fotoğrafı korunur.",
            presetClassic: "Klasik",
            presetMidnight: "Gece Yarısı",
            presetMono: "Mono",
            presetSunset: "Gün Batımı",
            presetOcean: "Okyanus",
            presetSakura: "Sakura",
            presetForest: "Orman",
            presetNeon: "Neon",
            presetPaper: "Kâğıt",
            presetBubblegum: "Sakız",
            presetSlate: "Kurumsal",
            presetGold: "Altın",

            bgType: "Arka plan",
            bgSolid: "Düz renk",
            bgGradient: "Geçiş",
            bgImage: "Fotoğraf",
            bgColor: "Renk",
            bgColorFrom: "Başlangıç",
            bgColorTo: "Bitiş",
            bgAngle: "Açı",
            bgPattern: "Desen",
            bgPhoto: "Arka plan fotoğrafı",
            bgPhotoHint: "Telefon ekranına göre kırpılır",
            bgPhotoPick: "Fotoğraf seç",
            bgPhotoReplace: "Fotoğrafı değiştir",
            bgBlur: "Bulanıklık",
            bgDim: "Karartma",
            pattern_none: "Yok",
            pattern_dots: "Nokta",
            pattern_grid: "Izgara",
            pattern_stripes: "Çizgi",
            pattern_rays: "Işın",

            cardStyle: "Kart",
            cardSolid: "Dolu",
            cardGlass: "Cam",
            cardNone: "Yok",
            cardColor: "Kart rengi",
            cardBorder: "Kenar rengi",
            cardOpacity: "Saydamlık",
            cardRadius: "Köşe yuvarlaklığı",
            avatarShape: "Profil fotoğrafı",
            avatarCircle: "Yuvarlak",
            avatarRounded: "Yumuşak",
            avatarSquare: "Kare",

            font: "Yazı tipi",
            textHeading: "Başlıklar",
            textBody: "Metin",
            textMuted: "İkincil metin",

            buttonsHint: "Profilinizdeki butonlar bağlantılarınız ve sosyal medya hesaplarınızdır.",
            btnFill: "Dolgu",
            fillSolid: "Dolu",
            fillOutline: "Çerçeve",
            fillGlass: "Cam",
            btnShadow: "Gölge",
            shadowNone: "Yok",
            shadowSoft: "Yumuşak",
            shadowHard: "Sert",
            btnRadius: "Köşe yuvarlaklığı",
            btnColor: "Buton rengi",
            btnText: "Buton yazısı",
            btnBorder: "Kenar rengi",
            accent: "Vurgu rengi",
            accentText: "Vurgu yazısı",

            cropTitle: "Arka plan fotoğrafı",
            cropHint: "Çerçevenin içinde kalan kısım ziyaretçilerin gördüğüdür.",

            previewBio: "Biyografiniz burada görünür",
            previewRowA: "Instagram",
            previewRowB: "Web sitem"
        },
        user: {
            linkDestination: "Bu bağlantı nereye gidiyor",
            openLink: "Bağlantıyı aç",
            showLink: "Bağlantıyı göster",
            linkWarning: "Devam etmeden önce adresi kontrol edin — bu adresi profil sahibi girdi.",
            contactBtn: "İletişim Kur",
            brandOnlyInbox: "Bu içerik üretici yalnızca marka hesaplarından mesaj kabul ediyor.",
            copyLink: "Profil linkini kopyala",
            closeBtn: "Kapat",
            unlock: "Kilidi Aç",
            buyCoffee: "Kahve Ismarla",
            coffeeName: "İsim (Opsiyonel)",
            coffeeMessage: "Mesajınız...",
            payCoffee: "Gönder",
            coffeeThanksTitle: "Teşekkürler!",
            coffeeThanksMessage: "Kahve başarıyla gönderildi."
        },
        search: {
            errorMsg: "Bir hata oluştu.",
            placeholder: "Kullanıcı adıyla ara...",
            loadMore: "Daha fazla yükle",
            tabUsername: "Kullanıcı Adı",
            tabSocial: "Sosyal Medya",
            tabProfile: "Profil Özellikleri",
            platform: "Platform",
            minFollowers: "Min Takipçi",
            maxFollowers: "Max Takipçi",
            sortBy: "Sıralama",
            sortStandard: "Standart",
            sortMostFollowers: "Önce en çok takipçi",
            sortLeastFollowers: "Önce en az takipçi",
            filterBtn: "Filtrele",
            clearFilters: "Temizle",
            tagsPlaceholder: "Kategoriler (Etiketler)",
            addBtn: "Ekle",
            // Hesabın profilinde belirttiği ülkeler — eski "hedef kitle
            // konumu" etiketi hiç var olmayan bir kitle dağılımını vaat
            // ediyordu.
            countryPlaceholder: "Ülke / Konum",
            countryHint: "Hesabın profilinde belirttiği ülkeler.",
            creatorOnly: "Sadece Doğrulanmışlar / Üreticiler",
            maxCountryAlert: "En fazla 5 ülke seçebilirsiniz.",
            maxTagAlert: "En fazla 10 etiket seçebilirsiniz.",
            negativeFollowersAlert: "Takipçi sayısı negatif olamaz.",
            minMaxAlert: "Min takipçi max takipçiden büyük olamaz.",

            hideFilters: "Filtreleri gizle",
            allPlatforms: "Tüm platformlar",
            sortRecommended: "Önerilen",
            sortRating: "En yüksek puan",
            sortEngagement: "En iyi etkileşim",
            sortPrice: "En düşük fiyat",
            everyone: "Herkes",
            creators: "Üreticiler",
            brands: "Markalar",
            verifiedOnly: "Doğrulanmış",
            hasMediaKit: "Medya kiti",
            hasRateCard: "Fiyat listesi",
            availabilityLabel: "Müsaitlik",
            anyAvailability: "Farketmez",
            minEngagement: "Min etkileşim %",
            budget: "Maks bütçe ($)",
            budgetHint: "Yayımlanmış alt sınırı bunun üstünde olan üreticileri gizler. Fiyat yayımlamamış olanlar listede kalır.",
            audience: "Erişim ve fiyat",
            profileFilters: "Profil",
            results: "{n} sonuç",
            empty: "Sonuç yok",
            emptyDesc: "Daha kısa bir isim deneyin ya da bir iki filtreyi kaldırın.",
            startTyping: "Bir hesap arayın",
            startTypingDesc: "Ya da filtreleri açıp platforma, erişime, fiyata ve müsaitliğe göre gezinin.",
            viewProfile: "Profil",
            mediaKit: "Medya kiti",
            selfReported: "Erişim ve etkileşim rakamları hesapların kendi beyanıdır.",
            moreTags: "+{n}",
            safetyTitle: "İletişime geçmeden önce",
            safetyBody: "Özellikle tanınmış bir isimse: profili açın, sosyal medya bağlantılarına tıklayın ve hesapların gerçekten ona ait olduğunu kontrol edin.",
            safetyClose: "Anladım"
        },
        admin: {
            tabContact: "Mesaj Gönder",
            tabPromo: "Promosyon Kodları",
            tabAddUser: "Kullanıcı Ekle",
            tabUsers: "Kullanıcılar",
            tabManuelSocial: "Manuel Sosyal İstekleri",
            tabSocials: "Sosyal Medya Yönetimi",
            tabDisputes: "Anlaşmazlıklar",
            tabReports: "Şikayetler",
            tabFinance: "Finans",
            noDisputes: "Şu anda anlaşmazlık yok.",
            noPayouts: "Çekim talebi yok.",
            disputeOpen: "Açık",
            disputeResolved: "Karara bağlandı",
            theBrief: "Brief",
            deliveries: "Teslimatlar",
            revisions: "Revizyon talepleri",
            ruling: "Karar",
            rulingNotePlaceholder: "İki tarafa not (opsiyonel)",
            creatorShare: "Üretici payı",
            awardCreator: "Üreticiye aktar",
            refundBrand: "Markaya iade et",
            splitAmount: "Paylaştır",
            confirmRuling: "Bu karar uygulansın mı? Yıldızlar anında hareket eder ve geri alınamaz.",
            replyPlaceholder: "Platform ekibi olarak yanıtla…",
            remainingBalance: "Kalan",
            approve: "Onayla",
            markPaid: "Ödendi işaretle",
            reject: "Reddet",
            promoTemplateTitle: "Mesaj Şablonu",
            promoTemplatePlaceholder: "Şablon (kod yeri için * kullanın)",
            clearBtn: "Temizle",
            createPromoTitle: "Promosyon Kodu Oluştur",
            promoNamePlaceholder: "İsim",
            promoAmountPlaceholder: "Miktar",
            addBtn: "Ekle",
            copied: "Kopyalandı!",
            percent: "Yüzde",
            amount: "Tutar",
            verificationRequests: "Doğrulama Talepleri",
            createUserTitle: "Kullanıcı Oluştur",
            usernamePlaceholder: "Kullanıcı Adı",
            emailPlaceholder: "E-posta",
            passwordPlaceholder: "Şifre",
            refreshBtn: "Yenile",
            usernameLabel: "Kullanıcı Adı",
            emailLabel: "E-posta",
            passwordLabel: "Şifre",
            brandVerified: "Marka Onaylı",
            creatorVerified: "Üretici Onaylı",
            trial: "Deneme Süresi",
            starsLabel: "Starlar",
            platformLabel: "Platform",
            followersLabel: "Takipçi",
            botFetch: "Getir",
            botFetchAll: "Tümünü otomatik doldur",
            botWorking: "Okunuyor…",
            botRead: "Okundu",
            botHint: "Her profilin herkese açık takipçi sayısını okuyup alana yazar. Onay yine sizde.",
            botErrNoPublicCount: "Bu platform sayıyı çıkış yapmış ziyaretçiye göstermiyor — elle bakın.",
            botErrUnsupported: "Bu platform için otomatik okuyucu yok.",
            botErrNotFound: "Profil bulunamadı.",
            botErrBlocked: "Platform isteği reddetti — sonra tekrar deneyin.",
            botErrRateLimited: "İstek sınırına takıldı — bir süre sonra tekrar deneyin.",
            botErrNetwork: "Platforma ulaşılamadı.",
            botErrUnreadable: "Sayfa açıldı ama takipçi sayısı okunamadı.",
            botErrNoUsername: "Bu istekte kullanıcı adı yok.",
            botErrNotInQueue: "Bu istek artık kuyrukta değil.",
            botErrRequestFailed: "Sorgu isteği başarısız oldu.",
            botErrInternal: "Okuyucu beklenmedik bir hatayla karşılaştı.",
            botErrUnknown: "Takipçi sayısı okunamadı.",
            linkLabel: "Bağlantı",
            updateDateLabel: "Güncelleme Tarihi",
            acceptBtn: "Kabul Et",
            declineBtn: "Reddet",
            updateBtn: "Güncelle",
            deleteBtn: "Sil",
            allUsers: "Tüm Kullanıcılar",
            usersWithStars: "Staru Olan Kullanıcılar",
            usersWithoutStars: "Staru Olmayan Kullanıcılar",
            total: "toplam",
            userId: "ID",
            userUsername: "Kullanıcı Adı",
            userEmail: "E-posta",
            userStars: "Starlar",
            thirdParty: "3. Taraf",
            unauthorizedTitle: "Yetkisiz Erişim",
            unauthorizedMsg: "Bu sayfaya erişim izniniz yok.",
            headerTitle: "Yönetici"
        },
        chats: {
            processingVid: "Video işleniyor...",
            newMessage: "Yeni Mesaj",
            subOnlyWarning: "Bu kullanıcı sadece kilidini açanlardan mesaj alıyor. Mesaj gönderemezsiniz.",
            newMessages: "Yeni Mesajlar",
            newNotif: "yeni mesaj",
            starsSent: "Star Gönderildi",
            showPrevious: "Önceki Mesajları Göster",
            notEnoughStars: "Yeterli starunuz yok.",
            starErrorMsg: "Star gönderilirken bir hata oluştu.",
            title: "Mesajlar",
            searchPlaceholder: "Konuşma ara...",
            tabChats: "Sohbetler",
            tabArchived: "Arşiv",
            tabBlocked: "Engellenenler",
            archiveBtn: "Arşivle",
            unarchiveBtn: "Arşivden Çıkar",
            selectConversation: "Bir konuşma seçin",
            unblockBtn: "Engeli Kaldır",
            blockBtn: "Engelle",
            uploadingVid: "Video yükleniyor...",
            sending: "Gönderiliyor",
            sendBtn: "Gönder",
            selected: "Seçildi: ",
            sendStars: "Star Gönder",
            giftStars: "Star hediye et:",
            writeMessage: "Mesaj yaz...",
            cancelBtn: "İptal",
            chooseFile: "Dosya Seç",
            noFileChosen: "Dosya seçilmedi"
        },
        creator: {
            saveError: "Tercihler kaydedilirken bir hata oluştu.",
            preferences: "Tercihler",
            restrictMedia: "Medya erişimini kısıtla",
            restrictMediaDesc: "Medya içeriğinizi yalnızca aboneler görüntüleyebilir",
            subMessaging: "Sadece aboneler mesaj atabilir",
            subMessagingDesc: "Size yalnızca aboneler mesaj gönderebilir",
            brandOnlyMessaging: "Sadece markalar",
            brandOnlyMessagingDesc: "Size yalnızca marka hesapları yazabilir — gelen kutunuz iş birliği tekliflerine kalır",
            messagingGatesNote: "İki filtre de açık. Markalar yine de doğrudan ulaşabilir; onlardan önce abone olmaları istenmez.",
            enableSubs: "Abonelikleri etkinleştir",
            enableSubsDesc: "Kullanıcıların içeriğinize abone olmasına izin verin",
            subPrice: "Abonelik fiyatı",
            subPriceDesc: "Aylık fiyatı kendiniz belirleyin. Abonelerinizden bu tutar dolar olarak tahsil edilir.",
            perMonth: "/ay",
            savePrice: "Kaydet",
            priceSaved: "Fiyat kaydedildi",
            priceRange: "Aylık {min} ile {max} arasında.",
            priceOutOfRange: "1 $ ile 5.000 $ arasında bir fiyat girin.",
            priceRequired: "Abonelikleri açmadan önce bir abonelik fiyatı belirleyin.",
            priceLive: "Abonelerinizden ayda {price} tahsil edilir.",
            subscribers: "Aboneler",
            total: "toplam",
            noSubs: "Henüz abone yok.",
            subscribedOn: "Abone olma tarihi",
            active: "Aktif",
            inactive: "Pasif",
            gallery: "Galeri",
            items: "öğe",
            uploading: "Yükleniyor...",
            addMedia: "Medya Ekle",
            photo: "Fotoğraf",
            video: "Video",
            noMedia: "Galerinize fotoğraf ve video yükleyin.",
            uploadError: "Medya yüklenemedi.",
            deleteError: "Medya silinemedi.",
            videoTag: "▶ Video",
            photoTag: "📷 Fotoğraf",
            enableCoffees: "Kahve ısmarlamasına izin ver",
            enableCoffeesDesc: "Kullanıcıların size kahve ısmarlamasına izin verin."
        },
        media: {
            photo: "Fotoğraf",
            video: "Video",
            close: "Kapat",
            next: "Sonraki",
            previous: "Önceki",
            openOriginal: "Orijinali aç",
        },
        gallery: {
            dropTitle: "Medyayı buraya sürükleyin veya seçmek için tıklayın",
            dropHint: "Fotoğraflar en fazla 10 MB · videolar en fazla 10 dakika",
            dropNow: "Yüklemek için bırakın",
            queued: "Sırada",
            uploading: "Yükleniyor",
            processing: "İşleniyor",
            saving: "Kaydediliyor",
            processingHint: "Video oynatma için hazırlanıyor",
            failed: "Yükleme başarısız",
            cancel: "İptal",
            dismiss: "Kapat",
            remove: "Sil",
            confirmRemove: "Sil",
            tooLarge: "Fotoğraflar en fazla 10 MB olabilir.",
            tooLong: "Videolar en fazla 10 dakika olabilir.",
            unsupported: "Yalnızca fotoğraf ve video yüklenebilir.",
            keepOpen: "Yükleme bitene kadar bu sayfayı açık tutun.",
        },
        accountType: {
            title: "Hesap Türünü Seçin",
            subtitle: "Platformu nasıl kullanmak istediğinizi seçin",
            creatorTitle: "İçerik Üreticisi",
            creatorDesc: "İçerik oluşturun, kitlenizi büyütün ve para kazanın.",
            brandTitle: "Marka",
            brandDesc: "İçerik üreticileri bulun ve reklam kampanyaları yönetin.",
            userTitle: "Kullanıcı",
            userDesc: "İçerikleri keşfedin ve içerik üreticileriyle bağlantı kurun.",
            submitBtn: "Devam Et",
            confirmTitle: "Emin misiniz?",
            confirmSelected: "Seçilen tür",
            confirmWarning: "Bunu sadece 1 kez değiştirebilirsiniz. Lütfen dikkatli seçin.",
            confirmCancel: "Geri Dön",
            confirmBtn: "Onayla"
        },
        finance: {
            coffeesTitle: "Kahveler",
            total: "Toplam",
            received: "Alınanlar",
            sent: "Gönderilenler",
            noCoffees: "Bu listede henüz kahve yok.",
            sentCoffee: "Gönderilen Kahve",
            noMessage: "Mesaj bırakılmadı.",
            anonymous: "İsimsiz",

            pageTitle: "Finans",
            pageSubtitle: "Tüm gelirleriniz, kesintileriniz ve ödemeleriniz tek ekranda.",

            availableBalance: "Çekilebilir bakiye",
            pending: "Bekleyen",
            lifetimeNet: "Toplam net",
            withdrawn: "Çekilen",
            payoutProgress: "Çekim limitine kalan",
            withdrawBtn: "Para çek",
            minimumNote: "En düşük çekim tutarı:",
            belowMinimum: "Bakiyeniz çekim limitinin altında.",
            alreadyPending: "İncelemede bekleyen bir çekim talebiniz var.",
            payoutError: "Çekim talebi gönderilemedi.",
            payoutPending: "Çekim talebi incelemede",
            confirmPayout: "Talep gönder",
            methodBank: "Banka havalesi",
            methodWise: "Wise",
            methodPaypal: "PayPal",
            accountPlaceholder: "IBAN / hesap bilgisi",
            payoutHistory: "Çekim geçmişi",
            payoutStatus_pending: "İncelemede",
            payoutStatus_approved: "Onaylandı",
            payoutStatus_paid: "Ödendi",
            payoutStatus_rejected: "Reddedildi",

            breakdownTitle: "Gelir kırılımı",
            breakdownHint: "Kaynak bazında brüt kazanç ve platform kesintisi sonrası net tutar.",
            source: "Kaynak",
            gross: "Brüt",
            fee: "Kesinti",
            net: "Net",
            source_subscription: "Abonelikler",
            source_coffee: "Kahveler",
            source_star: "Yıldızlar",
            source_campaign: "Kampanyalar",

            goalTitle: "Bu ay",
            goalHint: "Defter ne kadar kazandığınızı söyler. Bu, nasıl gittiğini söyler.",
            goalThisMonth: "bu ay kazanılan",
            goalLastMonthToDate: "geçen ay, aynı gün",
            goalLastMonthFull: "geçen ayın tamamı",
            goalNoBaseline: "yeni",
            goalProjection: "ay sonu tahmini",
            goalEstimate: "tahmin",
            goalInEscrow: "emanette",
            goalTarget: "Hedef",
            goalSet: "Aylık hedef belirle",
            goalSave: "Kaydet",
            goalClear: "Hedefi kaldır",
            goalPlaceholder: "örn. 2500",
            goalSaveError: "Hedef kaydedilemedi.",
            goalOnTrack: "Hedefe uygun",
            goalBehind: "Hedefin gerisinde",
            goalRemaining: "kalan:",
            goalReached: "Hedefe ulaşıldı",
            goalDailyNeeded: "Günlük gereken:",
            goalDaysLeft: "gün kaldı",
            goalPaceMarker: "Bugün tam hedefe uygun gitseydiniz olacağınız yer",
            platformFee: "Platform komisyonu",
            withholding: "Stopaj / vergi",
            payable: "Ödenecek tutar",
            taxNote: "Vergi tutarı yalnızca bilgilendirme amaçlı bir tahmindir; kendi beyanınızın yerine geçmez.",

            trendTitle: "Son 6 ay",
            trendHint: "Aylık net gelir.",

            starWallet: "Yıldız cüzdanı",
            onPayout: "çekimde",
            starBalance: "Bakiye",
            starPurposeNote: "Yıldızlar sohbette hediye göndermek içindir",
            escrowIncoming: "Sizin için kilitli",
            escrowOutgoing: "Kilitlediğiniz",

            pendingPaymentsTitle: "Bekleyen ödemeler",
            pendingPaymentsHint: "İş onaylandığında hesabınıza geçecek, havuzda kilitli tutar."
        },
        report: {
            title: "Hesabı şikayet et",
            subtitle: "Şikayet edilen:",
            reasonLabel: "Sorun nedir?",
            reason_spam: "Spam veya istenmeyen reklam",
            reason_harassment: "Taciz, tehdit veya hakaret",
            reason_scam: "Dolandırıcılık",
            reason_impersonation: "Başkasının kimliğine bürünme",
            reason_inappropriate: "Uygunsuz veya müstehcen içerik",
            reason_fake_followers: "Sahte takipçi veya etkileşim",
            reason_no_delivery: "Ödemeyi aldı, işi teslim etmedi",
            reason_other: "Başka bir şey",
            detailLabel: "Ne olduğunu anlatın",
            detailPlaceholder: "Tarih, bağlantı, ekran görüntüsü tarifi — ne kadar somut olursa o kadar hızlı işlem yapabiliriz.",
            detailRequired: "Lütfen sorunu açıklayın.",
            submit: "Şikayeti gönder",
            cancel: "Vazgeç",
            close: "Kapat",
            sent: "Şikayetiniz alındı",
            sentNote: "Ekibimiz her şikayeti inceliyor. Bu hesaba kimin şikayet ettiğini bildirmiyoruz.",
            alreadyReported: "Bu hesap hakkında zaten açık bir şikayetiniz var.",
            cannotReportSelf: "Kendi hesabınızı şikayet edemezsiniz.",
            error: "Şikayet gönderilemedi. Lütfen tekrar deneyin.",
            privacyNote: "Şikayetler gizlidir. Şikayet edilen hesaba kimin bildirdiği hiçbir zaman gösterilmez."
        },
        reports: {
            status_open: "Açık",
            status_reviewing: "İnceleniyor",
            status_resolved: "İşlem yapıldı",
            status_dismissed: "Reddedildi",
            filterOpen: "Açık",
            filterReviewing: "İncelenen",
            filterResolved: "İşlem yapılan",
            filterDismissed: "Reddedilen",
            filterAll: "Tümü",
            searchPlaceholder: "Kullanıcı adı veya metin ara…",
            empty: "Burada şikayet yok.",
            by: "şikayet eden:",
            deletedUser: "silinmiş hesap",
            reportedBadge: "şikayet",
            reporterSays: "Şikayet edenin ifadesi",
            noDetail: "Şikayet eden açıklama bırakmamış.",
            notePlaceholder: "İç not — ne yaptınız?",
            markReviewing: "İncelemeye al",
            actionTaken: "İşlem yapıldı",
            dismiss: "Reddet",
            reopen: "Yeniden aç",
            ruledBy: "Karar veren:",
            actionHint: "Şikayeti kapatmak taraflara bildirim göndermez. Gerekiyorsa hesabı ayrıca kısıtlayın veya yasaklayın."
        },
        wallet: {
            cardTitle: "Kampanya bakiyesi",
            cardHint: "Buraya yatırdığınız para kampanyaları finanse eder. Bir üreticiyi onayladığınızda havuzda tutulur; bu bakiye geri çekilemez.",
            spendableBalance: "Kampanya bakiyesi",
            spendable: "Harcanabilir",
            locked: "Havuzda",
            deposited: "Yatırılan",
            inEscrow: "Havuzda",
            history: "Bakiye hareketleri",

            depositBtn: "Para yatır",
            depositTitle: "Para yatır",
            depositHint: "Kampanya bakiyenizi kartla yükleyin. Yüklenen tutar anında harcanabilir hale gelir.",
            amountLabel: "Tutar",
            rangeNote: "Alt ve üst sınır:",
            continueToPayment: "Ödemeye geç",
            amountToPay: "Ödenecek tutar",
            payNow: "Öde",
            depositDone: "Ödeme alındı",
            newBalance: "Yeni bakiye",
            close: "Kapat",

            walletExplain: "Bu bakiye yalnızca kampanyalarda harcanır. Üretici kazançlarınız ayrı olarak çekilir.",
            securityNote: "Kart bilgileri doğrudan Stripe'a gider; sunucularımıza hiç uğramaz.",
            invalidAmount: "Geçerli bir tutar girin.",
            amountOutOfRange: "Girdiğiniz tutar izin verilen aralığın dışında.",
            startError: "Ödeme başlatılamadı. Lütfen tekrar deneyin.",
            noPublishableKey: "Kartla ödeme henüz yapılandırılmamış. Lütfen destek ekibiyle iletişime geçin.",
            paymentFailed: "Ödeme reddedildi.",
            paymentIncomplete: "Ödeme tamamlanmadı.",
            creditPending: "Ödeme alındı. Bakiyeniz birazdan güncellenecek.",

            kind_deposit: "Para yatırma",
            kind_escrow_lock: "Havuza kilitlendi",
            kind_escrow_refund: "Havuzdan iade",
            kind_admin: "Düzeltme",

            depositStatus_pending: "Bekliyor",
            depositStatus_succeeded: "Ödendi",
            depositStatus_failed: "Başarısız",
            depositStatus_canceled: "İptal edildi"
        },
        adminFinance: {
            totalOwed: "Üreticilere borç",
            totalOwedHint: "Hesaplandı, henüz ödenmedi",
            openRequests: "Açık talep",
            totalPaid: "Bugüne kadar ödenen",
            totalWallet: "Cüzdanlarda duran",
            totalWalletHint: "Yatırıldı, henüz harcanmadı",
            accounts: "Hesap",
            searchPlaceholder: "Kullanıcı adı veya e-posta ara…",
            filterAll: "Tümü",
            filterRequests: "Ödeme bekleyenler",
            filterOwed: "Bakiyesi olanlar",
            noAccounts: "Eşleşen hesap yok.",
            requestBadge: "talep",
            requestedAmount: "talep edilen",
            inEscrow: "havuzda",
            inWallet: "cüzdanda",
            joined: "katılım",

            tabOverview: "Genel bakış",
            tabLedger: "Kazanç defteri",
            tabPayouts: "Çekim talepleri",
            tabWallet: "Bakiye",
            tabStars: "Yıldız hareketleri",
            deposits: "Para yatırmalar",
            walletAdjust: "Bakiyeyi elle düzelt",
            walletAdjustHint: "İşaretli tutar: eksi değer bakiyeden düşer. Her düzeltme bakiye geçmişine yazılır.",
            walletApply: "Uygula",
            walletTooLow: "Cüzdanda bu kadar bakiye yok.",

            available: "Çekilebilir",
            settleable: "Kapatılabilir",
            settleableHint: "Açık talep dahil",
            feeTaken: "Alınan komisyon",
            deals: "İş birlikleri",
            description: "Detay",
            state: "Durum",
            noRows: "Henüz kayıt yok.",
            requested: "talep",
            processed: "işlem",

            earningStatus_available: "Çekilebilir",
            earningStatus_pending: "Bekliyor",
            earningStatus_paid: "Ödendi",

            starKind_gift: "Hediye",
            starKind_purchase: "Satın alındı",
            starKind_escrow_lock: "Havuza kilitlendi",
            starKind_escrow_release: "Aktarıldı",
            starKind_escrow_refund: "İade edildi",
            starKind_payout: "Nakde çevrildi",
            starKind_admin: "Yönetici düzeltmesi",

            manualPayTitle: "Parayı gönderdim — bakiyeyi kapat",
            manualPayHint: "Bunu ancak havale hesabınızdan gerçekten çıktıktan sonra kullanın. Tutar defterden düşülür ve ödenmiş bir çekim kaydı olarak yazılır; böylece geçmiş kendini açıklamaya devam eder.",
            openRequest: "Açık çekim talebi",
            amountLabel: "Gönderilen tutar",
            blankMeansAll: "Boş bırakırsanız tamamı kapatılır",
            methodLabel: "Yöntem",
            noteLabel: "Referans / not",
            notePlaceholder: "örn. havale ref #8891",
            settleBtn: "Bakiyeyi kapat",
            confirmLine1: "Bu işlem üreticinin bakiyesinden",
            confirmLine2: "tutarını düşer ve ödenmiş olarak kaydeder. Geri alınamaz.",
            confirmSettle: "Evet, gönderdim",
            balanceClear: "Bakiye temiz",
            balanceClearHint: "Bu hesaba şu anda borç yok.",
            nothingToSettle: "Kapatılacak bakiye yok.",
            invalidAmount: "0 ile kapatılabilir bakiye arasında bir tutar girin.",
            resetStars: "Yıldızları sıfırla",
            resetStarsConfirm: "Bu hesabın yıldız bakiyesi sıfırlansın mı?"
        },
        campaigns: {
            pageTitle: "Kampanyalar",
            pageSubtitle: "Markalarla içerik üreticilerinin buluştuğu yer.",
            tabShowcase: "Vitrin",
            tabMine: "Kampanyalarım",
            tabApplied: "Başvurularım",
            tabDiscover: "Üretici bul",
            tabForYou: "Sana özel",
            tabCalendar: "Takvim",
            tabContracts: "Sözleşmeler",
            newCampaign: "Yeni kampanya",

            open: "Açık",
            closed: "Kapalı",
            draft: "Taslak",
            applicants: "başvuran",
            approved: "onaylı",
            slots: "kontenjan",
            followers: "takipçi",
            commission: "komisyon",
            brandAccount: "Marka",
            netDays: "Vade",
            hours: "saat",
            months: "ay",
            days: "gün",

            searchPlaceholder: "Kampanya veya marka ara…",
            allPlatforms: "Tüm platformlar",
            allPaymentModels: "Tüm ödeme modelleri",
            openOnly: "Sadece açıklar",

            emptyShowcase: "Henüz kampanya yok",
            emptyShowcaseDesc: "Filtreleri temizlemeyi deneyin ya da biraz sonra tekrar bakın.",
            emptyMine: "Henüz kampanya yayınlamadınız",
            emptyMineDesc: "Brief'inizi yazın, bütçenizi belirleyin ve başvuru almaya başlayın.",
            emptyApplied: "Henüz başvurunuz yok",
            emptyAppliedDesc: "Vitrini gezin ve size uygun kampanyalara başvurun.",
            browseShowcase: "Vitrini gez",

            newTitle: "Yeni kampanya",
            editTitle: "Kampanyayı düzenle",
            formHint: "Brief ne kadar net olursa başvurular o kadar isabetli gelir.",
            basicsTitle: "Temel bilgiler",
            basicsHint: "İsim, kapak görseli ve içeriğin yayınlanacağı platformlar.",
            fieldTitle: "Başlık",
            titlePlaceholder: "örn. Yaz koleksiyonu lansmanı",
            fieldSummary: "Kısa özet",
            summaryPlaceholder: "İş birliğini bir cümleyle anlatın",
            fieldImages: "Görseller",
            imagesHint: "Her görsel 16:9 çerçevelenir — kampanya kartındaki oran budur. Kırpmayı yüklerken siz seçersiniz.",
            cover: "Kapak",
            makeCover: "Kapak yap",
            fieldPlatforms: "Platformlar",
            addPlatform: "Platform ekle…",
            platformGroup_social: "Sosyal & kısa video",
            platformGroup_live: "Canlı yayın & topluluk",
            platformGroup_audio: "Ses & müzik",
            platformGroup_video: "Video",
            platformGroup_writing: "Yazı & portfolyo",
            platformGroup_commerce: "Destek & mağaza",
            platformGroup_other: "Diğer kanallar",

            briefTitle: "Brief",
            briefHint: "İstediğiniz kadar başlık ekleyin; her biri kampanya sayfasında ayrı bir bölüm olarak görünür.",
            customSection: "Özel başlık",
            noSections: "Henüz bölüm yok — yukarıdaki hazır başlıklardan başlayın.",
            sectionTitlePlaceholder: "Başlık",
            sectionBodyPlaceholder: "Bu başlığın altına detayları yazın…",
            sectionBrief: "Brief",
            sectionGoal: "Amaç",
            sectionKpi: "KPI",
            sectionTone: "Marka tonu ve mesajı",
            sectionRestrictions: "Kısıtlamalar",
            sectionDeliverables: "Teslimat kalemleri",
            sectionTimeline: "Zaman çizelgesi",
            sectionRights: "Kullanım hakları",

            deliverablesTitle: "Teslimat kalemleri",
            deliverablesHint: "İçerik türü, platform ve adet.",
            addDeliverable: "Teslimat ekle",
            platform: "Platform",
            format: "Format",
            format_reels: "Reels",
            format_story: "Story",
            format_post: "Gönderi",
            format_short: "Short",
            format_video: "Video",
            format_live: "Canlı yayın",
            format_stream: "Stream",

            kpiTitle: "KPI",
            kpiHint: "Başarının nasıl ölçüleceği.",
            addKpi: "KPI ekle",
            kpiMetricPlaceholder: "örn. İzlenme",
            kpiTargetPlaceholder: "örn. 100b",

            budgetTitle: "Bütçe ve ödeme koşulları",
            budgetHint: "Bir içerik üreticisini onayladığınızda ücret kampanya bakiyenizden düşülür ve havuzda kilitlenir.",
            payment_fixed: "Sabit ücret",
            payment_affiliate: "Satış komisyonu",
            payment_barter: "Barter",
            payment_hybrid: "Karma",
            paymentDesc_fixed: "Kişi başı belirlenen ücret; işi onayladığınızda serbest bırakılır.",
            paymentDesc_affiliate: "İçerik üreticisi getirdiği satıştan pay alır.",
            paymentDesc_barter: "İçerik karşılığında ürün veya hizmet; nakit ödeme yapılmaz.",
            paymentDesc_hybrid: "Sabit ücret + komisyon ve/veya ürün.",
            fieldBudgetUsd: "Kişi başı bütçe (USD)",
            escrowNote: "Bu tutar kampanya bakiyenizden düşülür ve onaya kadar havuzda tutulur.",
            fieldCommission: "Komisyon (%)",
            fieldBarter: "Verilecek ürün / hizmet",
            barterPlaceholder: "örn. 2 çift spor ayakkabı + 1.500₺ hediye çeki",
            fieldPaymentTerms: "Ödeme vadesi (gün)",
            fieldSlots: "Alınacak içerik üretici sayısı",

            timelineTitle: "Zaman çizelgesi ve kurallar",
            timelineHint: "Tarihler, revizyon hakları ve inceleme süresi.",
            fieldApplicationDeadline: "Son başvuru tarihi",
            fieldDraftDue: "Taslak teslim tarihi",
            fieldPublishDate: "Yayın tarihi",
            fieldRevisionLimit: "Ücretsiz revizyon hakkı",
            fieldAutoApprove: "İnceleme süresi (saat)",
            autoApproveNote: "Bu süre içinde inceleme yapmazsanız iş otomatik onaylanır ve ödeme serbest bırakılır.",

            rightsTitle: "Kullanım hakları ve münhasırlık",
            rightsHint: "İçeriği ne kadar süre kullanabileceğiniz ve rakip kısıtı olup olmadığı.",
            fieldUsageRights: "Kullanım hakkı (ay)",
            fieldExclusivity: "Münhasırlık (gün)",
            fieldExclusivityNote: "Münhasırlık notu",
            exclusivityPlaceholder: "örn. 30 gün boyunca rakip spor giyim markalarıyla çalışılmaz",

            trackingTitle: "Takip ve hedefleme",
            trackingHint: "UTM linkleri, indirim kodları ve kimlerin başvurabileceği.",
            fieldUtm: "UTM linki",
            fieldDiscountCode: "İndirim kodu",
            fieldMinFollowers: "Minimum takipçi",
            fieldTags: "Etiketler",
            tagPlaceholder: "Etiket ekle",

            termsTitle: "Koşullar",
            escrowExplain: "Ödeme, iş onaylanana kadar platform havuzunda tutulur. Hiçbir taraf tek başına bu tutarı hareket ettiremez; anlaşmazlık halinde ekibimiz hakemlik yapar.",

            cancel: "Vazgeç",
            saveDraft: "Taslak kaydet",
            publish: "Yayınla",
            preview: "Önizle",
            edit: "Düzenle",
            archive: "Arşivle",
            archiveConfirm: "Bu kampanya arşivlensin mi?",
            archiveBlocked: "Hâlâ havuzda parası duran iş birlikleri var — kampanya bunun yerine duraklatıldı.",
            titleRequired: "Başlık zorunludur.",
            saveError: "Bir şeyler ters gitti. Lütfen tekrar deneyin.",
            uploadError: "Görsel yüklenemedi.",

            applyBtn: "Başvur",
            applyMessagePlaceholder: "Markaya neden uygun olduğunuzu anlatın…",
            sendApplication: "Başvuruyu gönder",
            withdrawBtn: "Başvuruyu çek",
            yourApplication: "Başvurunuz",
            showDetails: "Detayları göster",
            hideDetails: "Detayları gizle",
            openCampaign: "Kampanya sayfasını aç",
            ownCampaign: "Bu sizin kampanyanız.",
            creatorsOnly: "Sadece içerik üretici hesapları başvurabilir.",
            appStatus_pending: "Beklemede",
            appStatus_approved: "Onaylandı",
            appStatus_rejected: "Reddedildi",
            appStatus_withdrawn: "Geri çekildi",

            applicantsTitle: "Başvuranlar",
            noApplicants: "Henüz başvuru yok.",
            newApplications: "yeni",
            activeCollabs: "Aktif iş birlikleri",
            escrowAmount: "Havuza kilitlenecek",
            approveAndLock: "Onayla ve kilitle",
            reject: "Reddet",
            insufficientBalance: "Kampanya bakiyeniz bu tutarı karşılamıyor. Önce para yatırın.",
            shortBy: "eksik:",

            dealStatus_in_progress: "Devam ediyor",
            dealStatus_submitted: "Onay bekliyor",
            dealStatus_revision_requested: "Revizyon istendi",
            dealStatus_disputed: "Anlaşmazlıkta",
            dealStatus_completed: "Tamamlandı",
            dealStatus_cancelled: "İptal edildi",
            escrow_locked: "havuzda kilitli",
            escrow_frozen: "donduruldu",
            escrow_released: "aktarıldı",
            escrow_refunded: "iade edildi",
            escrow_split: "paylaştırıldı",

            submitWorkTitle: "İşi teslim et",
            deliveryLinkPlaceholder: "İçerik linki (gönderi, video, taslak…)",
            deliveryNotePlaceholder: "Markaya not (opsiyonel)",
            deliveryRequired: "Bir link ekleyin veya dosya yükleyin.",
            submitWork: "İşi teslim et",
            deliveryRound: "Teslimat",
            awaitingBrand: "Markanın onayı bekleniyor",
            timeLeft: "Kalan süre",
            autoApproveDue: "otomatik onaylanıyor",
            autoApproveExplain: "Marka süresi içinde inceleme yapmazsa iş otomatik onaylanır ve ödeme size aktarılır.",
            reviewWindow: "İnceleme süresi",
            approveAndPay: "Onayla ve öde",
            requestRevision: "Revizyon iste",
            reviewHint: "Onayladığınızda ödeme anında aktarılır ve bu işlem geri alınamaz.",
            awaitingCreator: "İçerik üreticisinin teslimatı bekleniyor.",
            revisionsUsed: "Revizyon",
            revisionRequested: "Revizyon istendi",

            revisionTitle: "Revizyon iste",
            revisionHint: "Brief'e uymayan kısımları işaretleyin. Anlaşmazlığa giderse hakem bu kaydı okur.",
            revisionNotePlaceholder: "Detay ekleyin (opsiyonel)",
            revisionReasonRequired: "Bir neden seçin veya sorunu açıklayın.",
            sendRevision: "Talebi gönder",
            reason_missing_hashtag: "İstenen hashtag veya link kullanılmamış.",
            reason_wrong_mention: "Marka/ürün adı yanlış kullanılmış.",
            reason_quality: "Video kalitesi veya formatı istenen gibi değil.",
            reason_brief_mismatch: "İçerik brief'e uymuyor.",
            reason_wrong_platform: "Yanlış platformda veya formatta yayınlanmış.",
            reason_late: "Anlaşılan tarihten sonra teslim edilmiş.",
            reason_other: "Diğer (aşağıda açıklanmıştır).",

            raiseDispute: "Anlaşmazlık başlat",
            disputeLockedHint: "Anlaşmazlık, ücretsiz revizyon hakları tükendiğinde açılabilir.",
            disputeFormTitle: "Neden anlaşmazlığa taşıyorsunuz?",
            disputeReasonPlaceholder: "Sorunu hakem için açıklayın…",
            startDispute: "Anlaşmazlığı başlat",
            disputeSuspended: "Bu kampanya askıya alınmıştır",
            disputeLocked: "Kilitli tutar",
            disputeResolved: "Karar",
            resolution_creator: "Ödeme içerik üreticisine aktarıldı.",
            resolution_brand: "Ödeme markaya iade edildi.",
            resolution_split: "Ödeme iki taraf arasında paylaştırıldı.",
            evidenceTitle: "Kanıtlar",
            evidencePlaceholder: "Açıklamanızı yazın…",
            evidenceHint: "Bu yazışmayı yalnızca iki taraf ve platform ekibi görebilir.",
            platformTeam: "Platform ekibi",
            send: "Gönder",
            dealCompleted: "İş birliği tamamlandı",
            dealCancelled: "İş birliği iptal edildi",
            creatorGot: "Üretici",
            brandGot: "Marka",

            proposedPrice: "Fiyatınız",
            brandBudget: "Markanın bütçesi",
            useProposed: "İstenen fiyatı kullan:",
            noRateCardHint: "Henüz fiyat listesi yayımlamadınız. Üretici sayfasından ekleyince tek dokunuşla teklif verebilirsiniz."
        },

        mediaKit: {
            title: "Medya kiti",
            pageTitle: "Medya kiti",
            subtitle: "Erişiminiz, kitleniz ve geçmiş işleriniz tek paylaşılabilir sayfada — PDF hazırlamanıza gerek yok.",
            statusPublished: "Yayında",
            statusDraft: "Taslak",

            reach: "erişim",
            engagement: "etkileşim",
            engagementShort: "etk.",
            completedDeals: "tamamlanan iş",
            views: "izlenme",

            completeness: "Doluluk",
            checkHeadline: "Tek satırlık tanıtım yazın",
            checkBio: "Ne yaptığınızı anlatın",
            checkReach: "Erişim ve etkileşim girin",
            checkAudience: "Kitle dağılımını ekleyin",
            checkSamples: "Örnek içerik seçin",
            checkCollabs: "Geçmiş iş birliklerini yazın",
            checkRates: "Fiyatlarınızı yayımlayın",

            autoAttachNote: "Medya kitiniz her kampanya başvurusuna otomatik iliştirilir — marka istemeden görür.",
            createBtn: "Medya kiti oluştur",
            editBtn: "Medya kitini düzenle",
            previewBtn: "Önizle",
            publishBtn: "Yayımla",
            unpublishBtn: "Yayından kaldır",
            showOnProfile: "Profilimde göster",
            showOnProfileHint: "Kapatsanız da sayfa yayında kalır — başvurunuzu okuyan markalar yine görür, yalnızca profiliniz artık bağlantı vermez.",

            editTitle: "Medya kiti",
            editHint: "Buradakiler, markanın karar vermeden önce okuduğu şeyler.",
            creatorsOnly: "Medya kitini yalnızca üretici hesapları yayımlayabilir.",
            saveDraft: "Taslak olarak kaydet",
            publish: "Kaydet ve yayımla",

            identityTitle: "Tanıtım",
            identityHint: "Markanın ilk okuduğu üç satır.",
            fieldHeadline: "Tek satırlık tanıtım",
            headlinePlaceholder: "Moda & yaşam tarzı üreticisi, İstanbul",
            fieldBio: "Hakkınızda",
            bioPlaceholder: "Kimin için içerik üretiyorsunuz, neyi iyi yapıyorsunuz…",
            fieldLocation: "Konum",
            locationPlaceholder: "İstanbul, TR",
            fieldContactEmail: "İletişim e-postası",
            fieldLanguages: "Diller",
            languagePlaceholder: "Türkçe",
            fieldCover: "Kapak görseli",
            coverHint: "Sayfanızın üstündeki banda göre kırpın — burada çerçevelediğiniz alan yayımlanır.",
            coverCropTitle: "Kapak görselini konumlandırın",
            replaceCover: "Kapağı değiştir",
            removeCover: "Kapağı kaldır",

            performanceTitle: "Erişim & etkileşim",
            performanceHint: "İş birliğine karar verdiren sayılar. Takipçi sayıları zaten kayıtlı — bunlar bir gönderinin gerçekte ne yaptığı.",
            avgReach: "Ort. erişim",
            avgViews: "Ort. izlenme",
            engagementRate: "Etkileşim %",
            noSocials: "Önce profilinize sosyal medya hesabı ekleyin — değerler hesap başına giriliyor.",
            selfReportedWarning: "Bu sayılar sizin beyanınız. Analiz ekranınızda ne yazıyorsa onu girin — şişirilmiş bulan marka sizinle ikinci kez çalışmaz.",
            selfReportedNote: "Erişim, etkileşim ve kitle verileri üreticinin kendi beyanıdır. Tamamlanan işler platform tarafından sayılır.",
            selfReportedShort: "Üretici beyanı",

            audienceTitle: "Kitle",
            audienceHint: "İçeriğinizi gerçekte kim görüyor. Analiz ekranınızdan aktarın.",
            audienceCountries: "Ülkeler",
            audienceAge: "Yaş",
            audienceGender: "Cinsiyet",
            countryPlaceholder: "Ülke",
            agePlaceholder: "Yaş aralığı",
            genderPlaceholder: "örn. Kadın",
            splitTotal: "Toplam",
            addRow: "Satır ekle",

            highlightsTitle: "Öne çıkanlar",
            highlightsHint: "İlk görülmesini istediğiniz iki üç sayı.",
            highlightLabelPlaceholder: "Ort. izlenme",
            highlightValuePlaceholder: "180B",

            collabsTitle: "Geçmiş iş birlikleri",
            otherCollabsTitle: "Diğer iş birlikleri",
            collabsHint: "Platform dışında yaptığınız işler. Burada tamamlananlar ayrıca ve doğrulanmış olarak listelenir.",
            collabBrandPlaceholder: "Marka",
            collabNotePlaceholder: "Ne ürettiniz",
            collabYearPlaceholder: "Yıl",
            addCollab: "İş birliği ekle",
            verifiedCollabs: "iş birliği platform üzerinden tamamlandı",
            verifiedCollabsDesc: "Bunlar emanet hesabımızdan geçti; iddia olarak değil, doğrulanmış olarak gösterilir.",
            showPlatformDeals: "Medya kitimde göster",
            verifiedBadge: "DOĞRULANMIŞ",

            samplesTitle: "Örnek içerikler",
            samplesHint: "Galerinizden seçin veya platformlarda duran işlerinize bağlantı verin.",
            noGallery: "Galeriniz boş — aşağıdan bağlantı ekleyebilirsiniz.",
            addSampleLink: "Bağlantı ekle",
            viewsPlaceholder: "İzlenme",
            rateCardHint: "Fiyatlar hem medya kitinizde hem profilinizde görünür.",

            shareTitle: "Özel bağlantı",
            shareHint: "Herkese açmadan önce sayfayı tek bir markaya gönderin.",
            copy: "Kopyala",
            copied: "Kopyalandı",
            share: "Paylaş",
            rotateToken: "Yeni bağlantı üret",
            rotateTokenHint: "Şimdiye kadar paylaştığınız bağlantıların hepsi çalışmaz olur.",

            platformsTitle: "Hesaplar",
            viewProfile: "Profili gör",
            updatedAt: "Güncellendi",
            openFullPage: "Medya kitinin tamamını aç",
            attachedShort: "Medya kiti iliştirildi",
            profileCtaDesc: "Erişim, kitle ve geçmiş işler",

            ownerDraftBanner: "Bu sayfa taslak — yalnızca siz ve özel bağlantınız elinde olanlar görebilir.",
            notPublished: "Bu medya kiti yayında değil",
            notPublishedDesc: "Üretici bu sayfayı henüz herkese açmadı.",
            goToProfile: "Profile git"
        },

        rateCard: {
            title: "Fiyat listesi",
            subtitle: "Fiyatlarınızı yayımlayın; pazarlık mesajlaşmada sıfırdan başlamasın.",
            published: "Yayında",
            publishedDesc: "Profilinizde, medya kitinizde ve gönderdiğiniz her başvuruda görünür.",
            draft: "Taslak",
            draftDesc: "Yalnızca siz görüyorsunuz. Yayımlamak için açın.",

            from: "başlangıç",
            packageTag: "Paket",
            minBudget: "Min. bütçe",
            barterOk: "Barter değerlendirilir",
            openToOffers: "Tekliflere açık",
            turnaround: "Teslim",
            revisionsIncluded: "Revizyon",

            addItem: "Satır ekle",
            noItems: "Henüz fiyatlandırılmış satır yok.",
            itemTitlePlaceholder: "Instagram Reels",
            itemDescPlaceholder: "Neler dahil (opsiyonel)",
            includesPlaceholder: "1× Reels, 3× Story  (virgülle ayırın)",
            isPackage: "Paket",
            lineActive: "Görünür",
            titleRequired: "Her satırın bir adı olmalı.",
            creatorsOnly: "Fiyat listesini yalnızca üretici hesapları yayımlayabilir.",

            minBudgetLabel: "Asgari bütçe",
            minBudgetHint: "Bunun altındaki başvurular size ulaşmadan elenir.",
            acceptsBarter: "Barter değerlendiririm",
            openToOffersLabel: "Tekliflere açığım",
            notePlaceholder: "örn. fiyatlar münhasırlık içermez",

            saveBtn: "Fiyat listesini kaydet",
            savedBtn: "Kaydedildi"
        },


        reputation: {
            title: "Sicil",
            reviews: "değerlendirme",
            brandHint: "Bu markanın platform üzerinden tamamlanan iş birliklerindeki davranışı.",
            creatorHint: "Bu üreticinin platform üzerinden tamamlanan iş birliklerindeki teslimat geçmişi.",
            emptyNote: "Platform üzerinde henüz tamamlanmış iş birliği yok.",
            wouldWorkAgain: "tekrar çalışmak ister",

            criterion_on_time: "Zamanında teslim",
            criterion_quality: "İçerik kalitesi",
            criterion_communication: "İletişim",
            criterion_brief_fit: "Brief'e uygunluk",
            criterion_paid_on_time: "Zamanında ödedi",
            criterion_brief_clarity: "Brief netliği",
            criterion_fair_review: "Adil değerlendirme",

            factsTitle: "Platform kayıtları",
            factsHint: "Emanet zaman çizelgesinden alınır, beyana dayanmaz \u2014 iki taraf da bunları değiştiremez.",
            factDeals: "İş birliği",
            factReviewedInTime: "Süresinde inceledi",
            factReviewSpeed: "Ort. inceleme süresi",
            factOnTime: "Tarihine uydu",
            factTurnaround: "Ort. teslim süresi",
            factDisputes: "Uyuşmazlık",
            lapsedWarning: "teslimat, inceleme süresi dolana kadar cevapsız bırakıldı.",

            panelTitle: "Bu iş birliğini değerlendir",
            panelTitleDone: "Değerlendirmen",
            panelHint: "İki değerlendirme de siz ikiniz yazana kadar gizli kalır.",
            todo: "Bekliyor",
            yourRating: "Sen dedin ki",
            theirRating: "O dedi ki",
            bothIn: "İki değerlendirme de yazıldı",
            awaitingThem: "Karşı taraf henüz değerlendirmedi",
            theirsSealed: "Karşı tarafın değerlendirmesi mühürlü",
            theirsSealedNote: "Sizi değerlendirdiler. Siz de yazdığınız anda görünür olacak.",
            overallQuestion: "Genel olarak, birlikte çalışmak nasıldı:",
            wouldWorkAgainQuestion: "Tekrar birlikte çalışmak isterim",
            commentPlaceholder: "Ne iyi gitti, ne gitmedi? (isteğe bağlı)",
            commentPlaceholderRequired: "Neyin yanlış gittiğini yazın \u2014 düşük puan için zorunlu.",
            commentRequired: "Neyin yanlış gittiğini yazın. Gerekçesiz düşük puan ne cevaplanabilir ne de düzeltilebilir.",
            commentRequiredHint: "1 veya 2 puan, yayımlanabilmesi için bir açıklama gerektirir.",
            pickOverall: "Genel puan seçin.",
            submitBtn: "Değerlendirmeyi gönder",
            updateBtn: "Değerlendirmeyi güncelle",
            sealed: "Mühürlü",
            editableWhileSealed: "Yayımlanana kadar bunu değiştirebilirsiniz.",
            blindNote: "Değerlendirmeler iki taraf da yazana kadar ya da iş bittikten sonra {days} gün boyunca mühürlü kalır.",
            alreadyPublished: "Bu değerlendirme yayımlandı ve artık değiştirilemez.",
            windowClosed: "Bu iş birliği için değerlendirme süresi doldu.",

            pendingTitle: "Değerlendirilecek iş birlikleri",
            pendingHint: "Zamanında ödeyen markayı değerlendirmek, bir sonraki üreticinin bunu öğrenme yoludur.",
            rateBtn: "Değerlendir"
        },

        contract: {
            title: "İş birliği sözleşmesi",
            signed: "İmzalandı",
            frozenNote: "Bu şartlar, emanet kapandığı anda donduruldu. Kampanyada sonradan yapılan değişiklikler bu belgeyi değiştirmez.",
            brand: "Marka",
            creator: "Üretici",
            amount: "Anlaşma bedeli",
            fee: "Platform komisyonu",
            net: "Üreticiye net",
            draftDue: "Taslak teslim",
            publishDate: "Yayın tarihi",
            usageRights: "Kullanım hakkı",
            exclusivity: "Münhasırlık",
            exclusivityNote: "Münhasırlık kapsamı",
            revisionLimit: "Ücretsiz revizyon",
            acceptBtn: "Onayla",
            awaiting: "Onay bekleniyor",
            digest: "Belge özeti",
            downloadBtn: "PDF indir",
            downloadError: "Belge indirilemedi.",
            loadError: "Sözleşme yüklenemedi."
        },

        contracts: {
            hint: "Taraf olduğunuz tüm sözleşmeler. Ne zaman kapanmış olursa olsun, her iş birliğinin imzalı PDF'ini buradan indirebilirsiniz.",
            searchPlaceholder: "Marka, üretici veya kampanya ara",
            state_all: "Tümü",
            state_open: "Devam eden",
            state_closed: "Kapanan",
            role_any: "İki taraf",
            role_brand: "Marka olarak",
            role_creator: "Üretici olarak",
            needsYou: "Onayınız bekleniyor",
            needsYouBanner: "sözleşme onayınızı bekliyor.",
            view: "Detay",
            hide: "Kapat",
            empty: "Henüz sözleşme yok",
            emptyDesc: "Bir iş birliği onaylanıp ödeme emanete alındığı anda sözleşme düzenlenir. Sizinkiler burada görünecek.",
            emptyFiltered: "Eşleşen sözleşme yok",
            emptyFilteredDesc: "Bu aramaya uyan sözleşme bulunamadı. Farklı bir isim deneyin veya filtreleri temizleyin."
        },

        calendar: {
            view_agenda: "Ajanda",
            view_month: "Ay",
            type_draft_due: "Taslak teslimi",
            type_publish: "Yayın",
            type_review_deadline: "İnceleme son tarihi",
            type_application_deadline: "Başvurular kapanıyor",
            type_application_pending: "Başvuru bekliyor",
            planned: "planlanan",
            urgency_overdue: "Gecikti",
            urgency_today: "Bugün",
            urgency_soon: "Bu hafta",
            urgency_upcoming: "Yaklaşan",
            urgency_done: "Tamam",
            overdueTitle: "Geciken",
            upcomingTitle: "Yaklaşanlar",
            doneTitle: "Tamamlanan",
            empty: "Takvimde bir şey yok",
            emptyDesc: "İş birliklerinizdeki taslak ve yayın tarihleri burada otomatik olarak görünür.",
            weekday_0: "Pzt",
            weekday_1: "Sal",
            weekday_2: "Çar",
            weekday_3: "Per",
            weekday_4: "Cum",
            weekday_5: "Cmt",
            weekday_6: "Paz"
        },

        availability: {
            title: "Müsaitlik",
            hint: "Markalara iş alıp almadığınızı söyleyin. Sizi henüz aramamış bir markanın önüne çıkaran şey budur.",
            statusLabel: "Şu anda",
            status_none: "Belirtmek istemiyorum",
            status_open: "İşe açığım",
            status_limited: "Sınırlı",
            status_busy: "Doluyum",
            status_closed: "İş almıyorum",
            statusDesc_none: "Profilinizde müsaitlikle ilgili hiçbir şey görünmez",
            statusDesc_open: "Yeni iş birliklerine açık",
            statusDesc_limited: "Bir iki iş daha alabilirim",
            statusDesc_busy: "Dolu, ama ileri tarih için konuşulabilir",
            statusDesc_closed: "Önerilerde görünmez",
            availableFrom: "Şu tarihten sonra müsaitim",
            availableFromDesc: "\"12'sinden sonra\" demek, düz bir hayırdan çok daha işe yarar.",
            openToWork: "İş arıyorum",
            openToWorkLabel: "\"İş arıyorum\" rozetini göster",
            openToWorkDesc: "Profilinizde, basın sayfanızda ve her başvuru satırında yeşil bir rozet.",
            notePlaceholder: "Markaların bilmesi gereken tek satır (örn. Ekim için rezervasyon alıyorum)",
            categoriesLabel: "Hangi alanlarda çalışıyorsunuz",
            categoriesDesc: "Brief eşleştirmesinde kullanılır. Markanın kampanyasını tarif ediş biçimine ne kadar yakınsa o kadar üst sırada çıkarsınız.",
            categoriesPlaceholder: "örn. güzellik, seyahat, oyun",
            platformsLabel: "İş almak istediğiniz platformlar",
            discoverableLabel: "Önerilerde görün",
            discoverableDesc: "Kapatırsanız profiliniz herkese açık kalır ama marka listelerinde çıkmazsınız.",
            save: "Müsaitliği kaydet",
            saved: "Kaydedildi"
        },

        discover: {
            searchPlaceholder: "Üretici ara\u2026",
            budget: "Bütçe",
            budgetHint: "Yayımlanmış fiyatı bu bütçeye uyan üreticiler üst sırada çıkar; alt sınırı bütçenin üzerinde olanlar işaretlenir.",
            match: "Uyum",
            reach: "erişim",
            engagement: "etkileşim",
            from: "başlangıç",
            viewKit: "Medya kiti",
            contact: "İletişime geç",
            empty: "Üretici bulunamadı",
            emptyDesc: "Filtreleri gevşetin ya da bütçe koşulunu kaldırıp herkesi görün.",

            reason_platform: "Şurada paylaşıyor: ",
            reason_category: "Şu alanda çalışıyor: ",
            reason_country: "Kitlesi burada: ",
            reason_budget_fit: "Bütçenize uyuyor \u00b7 başlangıç ",
            reason_over_budget: "Alt sınırı bütçenizin üstünde \u00b7 ",
            reason_open_to_offers: "Tekliflere açık",
            reason_open_to_work: "İş arıyor",
            reason_free_from: "Şu tarihten müsait: ",
            reason_rating: "Puanı ",
            reason_brand_rating: "Marka puanı ",
            reason_fresh_stats: "Rakamları yakın zamanda güncellenmiş",

            suggestTitle: "Önerilen üreticiler",
            suggestHint: "Bu brief'e göre eşleştirildi \u2014 platform, etiket, bütçe",
            suggestEmpty: "Bu brief için eşiği geçen kimse yok. Platformları ya da bütçeyi genişletmek genelde işe yarar.",

            forYouHint: "Zaten yayımladığınız platform, alan ve fiyatlara göre eşleştirilmiş açık kampanyalar.",
            forYouEmpty: "Henüz eşleşme yok",
            forYouEmptyDesc: "Müsaitlik bölümünden platformlarınızı ve alanlarınızı ekleyin, bir fiyat listesi yayımlayın \u2014 eşleştirme bunları okuyor."
        },

        templates: {
            label: "Şablonlar",
            manage: "Yönet",
            done: "Bitti",
            edit: "Düzenle",
            saveThis: "Bu notu kaydet",
            newTemplate: "Yeni şablon",
            emptyHint: "Teslimat notunu bir kez kaydedin, her teslimde yeniden kullanın.",
            namePlaceholder: "Şablon adı (örn. Reels teslimi)",
            notePlaceholder: "Teslimatla birlikte gönderdiğiniz not…",
            checklistPlaceholder: "Kontrol listesi: hashtag eklendi, marka etiketlendi  (virgülle ayırın)",
            nameRequired: "Şablona bir ad verin.",
            emptyTemplate: "Bir not ya da kontrol listesi yazın — boş şablon kimseye yazı yazdırmaktan kurtarmaz.",
            limitReached: "Şablon sınırına ulaştınız.",
            saveBtn: "Kaydet"
        },

        imageCrop: {
            title: "Görseli konumlandırın",
            hint: "Sürükleyerek kaydırın, kaydırıcıyla yakınlaştırın. Çerçevenin içinde ne görüyorsanız yayında o görünür.",
            zoom: "Yakınlaştır",
            save: "Bu görseli kullan",
            cancel: "Vazgeç",
            skip: "Bunu atla",
            uploading: "Yükleniyor…",
            preparing: "Hazırlanıyor…",
            error: "Bu dosya açılamadı."
        }
    }
};

export default translations;
